import ClearableSearchInput from '../components/common/ClearableSearchInput.jsx'

const UnbundledLineItemsPage = () => (
  <div className="container-orders">
    <div className="sub-container-orders _2">
      <div className="container-topbar-orders gridd">
        <div className="grid-topbar-orders unbundled-list">
          <div
            id="w-node-_35b7b17b-b258-c301-288a-2dcfad452204-b74eabf4"
            className="heading-container aligned-left no-padding"
          >
            <div className="div-block-351">
              <div className="grid-order-icons mobile">
                <h2 className="heading-title right-margin x2">Unbundled Line Items</h2>
              </div>
            </div>
          </div>
        </div>
        <div className="w-layout-grid grid-92">
          <div className="grid-container-controls no-padding">
            <div className="grid-search-bar">
              <div>
                <form action="/search" className="search w-form">
                  <input type="submit" value="." className="search-button w-button" />
                  <ClearableSearchInput
                    className="input smaller w-input"
                    maxLength="256"
                    name="query"
                    placeholder="Search by Order Name or Status..."
                    id="search"
                    required=""
                  />
                </form>
              </div>
              <div className="form-block w-form">
                <form
                  id="email-form"
                  name="email-form"
                  data-name="Email Form"
                  method="get"
                  className="form"
                >
                  <select
                    id="field-3"
                    name="field-3"
                    data-name="Field 3"
                    className="filter-select-field w-select"
                  >
                    <option value="Status">Status</option>
                    <option value="Open">Open</option>
                    <option value="Oldest to Newest">Paid</option>
                    <option value="Printing">Printing</option>
                    <option value="Framing">Framing</option>
                    <option value="Canceled">Canceled</option>
                    <option value="Shipped">Shipped</option>
                  </select>
                </form>
                <div className="w-form-done">
                  <div>Thank you! Your submission has been received!</div>
                </div>
                <div className="w-form-fail">
                  <div>Oops! Something went wrong while submitting the form.</div>
                </div>
              </div>
              <div
                id="w-node-eb08ab27-3ecd-1d2b-4d94-73f415ee8924-b74eabf4"
                className="form-block w-form"
              >
                <form
                  id="email-form"
                  name="email-form"
                  data-name="Email Form"
                  method="get"
                  className="form"
                >
                  <select
                    id="field-2"
                    name="field-2"
                    data-name="Field 2"
                    className="filter-select-field w-select"
                  >
                    <option value="Paper Type">Paper Type</option>
                    <option value="Open">Open</option>
                    <option value="Oldest to Newest">Paid</option>
                    <option value="Printing">Printing</option>
                    <option value="Framing">Framing</option>
                    <option value="Canceled">Canceled</option>
                    <option value="Shipped">Shipped</option>
                  </select>
                </form>
                <div className="w-form-done">
                  <div>Thank you! Your submission has been received!</div>
                </div>
                <div className="w-form-fail">
                  <div>Oops! Something went wrong while submitting the form.</div>
                </div>
              </div>
            </div>
            <div data-hover="false" data-delay="0" className="dropdown w-dropdown">
              <div className="filter-select-field radius w-dropdown-toggle">
                <div className="icon small left-margin w-embed">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="currentcolor" viewBox="0 0 256 256">
                    <rect width="256" height="256" fill="none" />
                    <rect
                      x="40"
                      y="40"
                      width="176"
                      height="176"
                      rx="8"
                      strokeWidth="24"
                      stroke="currentcolor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      fill="Wne"
                    />
                    <line
                      x1="176"
                      y1="20"
                      x2="176"
                      y2="40"
                      fill="none"
                      stroke="currentcolor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="24"
                    />
                    <line
                      x1="80"
                      y1="20"
                      x2="80"
                      y2="40"
                      fill="none"
                      stroke="currentcolor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="24"
                    />
                    <line
                      x1="40"
                      y1="88"
                      x2="216"
                      y2="88"
                      fill="none"
                      stroke="currentcolor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="24"
                    />
                  </svg>
                </div>
              </div>
              <nav className="dropdown-list date w-dropdown-list">
                <div className="form-block-2-copy w-form">
                  <form
                    id="email-form-3"
                    name="email-form-3"
                    data-name="Email Form 3"
                    method="get"
                    className="form-3-copy"
                  >
                    <div className="div-block-64">
                      <div className="div-block-65">
                        <div className="icon small right-margin x2 w-embed">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="currentcolor"
                            viewBox="0 0 256 256"
                          >
                            <rect width="256" height="256" fill="none" />
                            <path d="M207.99414,31.9971h-24v-8a8,8,0,1,0-16,0v8h-80v-8a8,8,0,0,0-16,0v8h-24a16.01583,16.01583,0,0,0-16,16v160a16.01582,16.01582,0,0,0,16,16h160a16.01581,16.01581,0,0,0,16-16v-160A16.01582,16.01582,0,0,0,207.99414,31.9971Zm0,48h-160v-32h24v8a8,8,0,0,0,16,0v-8h80v8a8,8,0,1,0,16,0v-8h24Z" />
                          </svg>
                        </div>
                        <div>By Date Range</div>
                      </div>
                      <div className="w-layout-grid grid-18">
                        <div>
                          <div>Since</div>
                          <input
                            type="text"
                            className="datepicker w-input"
                            maxLength="256"
                            name="Check-out-3"
                            data-name="Check Out 3"
                            placeholder="MM/DD/YY"
                            id="Check-out-3"
                            required=""
                          />
                        </div>
                        <div>
                          <div>Until</div>
                          <input
                            type="text"
                            className="datepicker w-input"
                            maxLength="256"
                            name="Check-out-2"
                            data-name="Check Out 2"
                            placeholder="MM/DD/YY"
                            id="Check-out-2"
                            required=""
                          />
                        </div>
                      </div>
                    </div>
                  </form>
                  <div className="w-form-done">
                    <div>Thank you! Your submission has been received!</div>
                  </div>
                  <div className="w-form-fail">
                    <div>Oops! Something went wrong while submitting the form.</div>
                  </div>
                </div>
                <div className="div-block-66" />
                <div className="form-block-2-copy w-form">
                  <form
                    id="email-form-3"
                    name="email-form-3"
                    data-name="Email Form 3"
                    method="get"
                    className="form-3-copy"
                  >
                    <label className="radio-button-field w-radio">
                      <div className="w-form-formradioinput w-form-formradioinput--inputType-custom radio-button w-radio-input " />
                      <input
                        type="radio"
                        data-name="Radio 10"
                        id="radio-10"
                        name="radio"
                        value="Radio"
                        style={{ opacity: 0, position: 'absolute', zIndex: -1 }}
                      />
                      <span className="w-form-label" htmlFor="radio-10">
                        Today
                      </span>
                    </label>
                    <label className="radio-button-field w-radio">
                      <div className="w-form-formradioinput w-form-formradioinput--inputType-custom radio-button w-radio-input " />
                      <input
                        type="radio"
                        data-name="Radio 11"
                        id="radio-11"
                        name="radio"
                        value="Radio"
                        style={{ opacity: 0, position: 'absolute', zIndex: -1 }}
                      />
                      <span className="w-form-label" htmlFor="radio-11">
                        Yesterday
                      </span>
                    </label>
                    <label className="radio-button-field w-radio">
                      <div className="w-form-formradioinput w-form-formradioinput--inputType-custom radio-button w-radio-input " />
                      <input
                        type="radio"
                        data-name="Radio 12"
                        id="radio-12"
                        name="radio"
                        value="Radio"
                        style={{ opacity: 0, position: 'absolute', zIndex: -1 }}
                      />
                      <span className="w-form-label" htmlFor="radio-12">
                        This Week
                      </span>
                    </label>
                    <label className="radio-button-field w-radio">
                      <div className="w-form-formradioinput w-form-formradioinput--inputType-custom radio-button w-radio-input " />
                      <input
                        type="radio"
                        data-name="Radio 13"
                        id="radio-13"
                        name="radio"
                        value="Radio"
                        style={{ opacity: 0, position: 'absolute', zIndex: -1 }}
                      />
                      <span className="w-form-label" htmlFor="radio-13">
                        Last 30 days
                      </span>
                    </label>
                    <label className="radio-button-field w-radio">
                      <div className="w-form-formradioinput w-form-formradioinput--inputType-custom radio-button w-radio-input " />
                      <input
                        type="radio"
                        data-name="Radio 14"
                        id="radio-14"
                        name="radio"
                        value="Radio"
                        style={{ opacity: 0, position: 'absolute', zIndex: -1 }}
                      />
                      <span className="w-form-label" htmlFor="radio-14">
                        Last 3 Months
                      </span>
                    </label>
                  </form>
                  <div className="w-form-done">
                    <div>Thank you! Your submission has been received!</div>
                  </div>
                  <div className="w-form-fail">
                    <div>Oops! Something went wrong while submitting the form.</div>
                  </div>
                </div>
                <div className="w-layout-grid grid-19">
                  <div className="container-info-filter bg">
                    <div className="icon small right-margin x2 w-embed">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="currentcolor"
                        viewBox="0 0 256 256"
                      >
                        <rect width="256" height="256" fill="none" />
                        <polyline
                          points="79.833 99.716 31.833 99.716 31.833 51.716"
                          fill="none"
                          stroke="currentcolor"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="24"
                        />
                        <path
                          d="M65.7746,190.2254a88,88,0,1,0,0-124.4508L31.83348,99.71573"
                          fill="none"
                          stroke="currentcolor"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="24"
                        />
                      </svg>
                    </div>
                    <div>Reset All</div>
                  </div>
                  <div className="container-info-filter _1">
                    <div className="icon small right-margin x2 w-embed">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="currentcolor"
                        viewBox="0 0 256 256"
                      >
                        <rect width="256" height="256" fill="none" />
                        <path d="M232.3125,114.34375,88.34375,26.35937A15.99781,15.99781,0,0,0,64,40.00781V215.99219a16.00521,16.00521,0,0,0,24.34375,13.64843L232.3125,141.65625a16.00727,16.00727,0,0,0,0-27.3125Z" />
                      </svg>
                    </div>
                    <div>Filter Now</div>
                  </div>
                </div>
              </nav>
            </div>
            <div data-hover="false" data-delay="0" className="dropdown w-dropdown">
              <div className="filter-select-field radius w-dropdown-toggle">
                <div className="icon small left-margin w-embed">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="currentcolor" viewBox="0 0 256 256">
                    <rect width="256" height="256" fill="none" />
                    <polyline
                      points="144 167.994 184 207.994 223.999 168"
                      fill="none"
                      stroke="currentcolor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="24"
                    />
                    <line
                      x1="184"
                      y1="111.99347"
                      x2="184"
                      y2="207.99347"
                      fill="none"
                      stroke="#currentcolor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="24"
                    />
                    <line
                      x1="48"
                      y1="127.99353"
                      x2="119.99902"
                      y2="127.99353"
                      fill="none"
                      stroke="currentcolor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="24"
                    />
                    <line
                      x1="48"
                      y1="63.99353"
                      x2="183.99902"
                      y2="63.99353"
                      fill="none"
                      stroke="currentcolor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="24"
                    />
                    <line
                      x1="48"
                      y1="191.99353"
                      x2="104"
                      y2="191.99353"
                      fill="none"
                      stroke="currentcolor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="24"
                    />
                  </svg>
                </div>
              </div>
              <nav className="dropdown-list sort w-dropdown-list">
                <div className="form-block-filter w-form">
                  <form
                    id="email-form-3"
                    name="email-form-3"
                    data-name="Email Form 3"
                    method="get"
                    className="form-3"
                  >
                    <label className="radio-button-field w-radio">
                      <div className="w-form-formradioinput w-form-formradioinput--inputType-custom radio-button w-radio-input " />
                      <input
                        type="radio"
                        data-name="Radio 15"
                        id="radio-15"
                        name="radio"
                        value="Radio"
                        style={{ opacity: 0, position: 'absolute', zIndex: -1 }}
                      />
                      <span className="w-form-label" htmlFor="radio-15">
                        Ascending (A-Z)
                      </span>
                    </label>
                    <label className="radio-button-field w-radio">
                      <div className="w-form-formradioinput w-form-formradioinput--inputType-custom radio-button w-radio-input " />
                      <input
                        type="radio"
                        data-name="Radio 16"
                        id="radio-16"
                        name="radio"
                        value="Radio"
                        style={{ opacity: 0, position: 'absolute', zIndex: -1 }}
                      />
                      <span className="w-form-label" htmlFor="radio-16">
                        Descending (Z-A)
                      </span>
                    </label>
                    <label className="radio-button-field w-radio">
                      <div className="w-form-formradioinput w-form-formradioinput--inputType-custom radio-button w-radio-input " />
                      <input
                        type="radio"
                        data-name="Radio 17"
                        id="radio-17"
                        name="radio"
                        value="Radio"
                        style={{ opacity: 0, position: 'absolute', zIndex: -1 }}
                      />
                      <span className="w-form-label" htmlFor="radio-17">
                        Newest to Oldest
                      </span>
                    </label>
                    <label className="radio-button-field w-radio">
                      <div className="w-form-formradioinput w-form-formradioinput--inputType-custom radio-button w-radio-input " />
                      <input
                        type="radio"
                        data-name="Radio 18"
                        id="radio-18"
                        name="radio"
                        value="Radio"
                        style={{ opacity: 0, position: 'absolute', zIndex: -1 }}
                      />
                      <span className="w-form-label" htmlFor="radio-18">
                        Oldest to Newest
                      </span>
                    </label>
                  </form>
                  <div className="w-form-done">
                    <div>Thank you! Your submission has been received!</div>
                  </div>
                  <div className="w-form-fail">
                    <div>Oops! Something went wrong while submitting the form.</div>
                  </div>
                </div>
              </nav>
            </div>
            <div data-hover="false" data-delay="0" className="dropdown w-dropdown">
              <div className="filter-select-field radius filter w-dropdown-toggle">
                <div className="icon small left-margin w-embed">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="currentcolor" viewBox="0 0 256 256">
                    <rect width="256" height="256" fill="none" />
                    <path
                      d="M42.08441,48H213.91559a8,8,0,0,1,5.91952,13.38138l-65.75463,72.33009A8,8,0,0,0,152,139.09285v56.62568a8,8,0,0,1-3.5624,6.6564l-32,21.33334A8,8,0,0,1,104,217.05186v-77.959a8,8,0,0,0-2.08048-5.38138L36.16489,61.38138A8,8,0,0,1,42.08441,48Z"
                      fill="none"
                      stroke="currentcolor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="24"
                    />
                  </svg>
                </div>
              </div>
              <nav className="dropdown-list filter w-dropdown-list">
                <div className="container-info-filter specific-dates">
                  <div className="form-block-5 w-form">
                    <form
                      id="email-form-5"
                      name="email-form-5"
                      data-name="Email Form 5"
                      method="get"
                    >
                      <div className="div-block-45 urgency">
                        <label className="w-checkbox checkbox-field">
                          <div className="w-checkbox-input w-checkbox-input--inputType-custom checkbox " />
                          <input
                            type="checkbox"
                            id="checkbox-7"
                            name="checkbox-7"
                            data-name="Checkbox 7"
                            style={{ opacity: 0, position: 'absolute', zIndex: -1 }}
                          />
                          <span className="urgency w-form-label" htmlFor="checkbox-7">
                            Urgent
                          </span>
                        </label>
                        <div className="icon small x2 w-embed">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="currentcolor"
                            viewBox="0 0 256 256"
                          >
                            <rect width="256" height="256" fill="none" />
                            <g>
                              <path d="M221.048,175.93066C215.09778,165.7168,208.004,146.335,208.004,112v-7.0957c0-44.28516-35.61621-80.57813-79.39453-80.90235-.20508-.001-.40722-.002-.61133-.002A79.99928,79.99928,0,0,0,48.004,104v8c0,34.33105-7.09668,53.71387-13.0498,63.92676A15.999,15.999,0,0,0,48.76478,200h158.4707a15.99861,15.99861,0,0,0,13.8125-24.06934Z" />
                              <path d="M159.92884,216h-64a8,8,0,1,0,0,16h64a8,8,0,1,0,0-16Z" />
                            </g>
                          </svg>
                        </div>
                      </div>
                    </form>
                    <div className="w-form-done">
                      <div>Thank you! Your submission has been received!</div>
                    </div>
                    <div className="w-form-fail">
                      <div>Oops! Something went wrong while submitting the form.</div>
                    </div>
                  </div>
                </div>
                <div className="form-block-filter w-form">
                  <form
                    id="email-form-3"
                    name="email-form-3"
                    data-name="Email Form 3"
                    method="get"
                    className="form-3"
                  >
                    <div className="div-block-45">
                      <label className="w-checkbox checkbox-field">
                        <div className="w-checkbox-input w-checkbox-input--inputType-custom checkbox " />
                        <input
                          type="checkbox"
                          id="checkbox-7"
                          name="checkbox-7"
                          data-name="Checkbox 7"
                          style={{ opacity: 0, position: 'absolute', zIndex: -1 }}
                        />
                        <span className="w-form-label" htmlFor="checkbox-7">
                          Admin Note
                        </span>
                      </label>
                    </div>
                    <div className="div-block-45">
                      <label className="w-checkbox checkbox-field">
                        <div className="w-checkbox-input w-checkbox-input--inputType-custom checkbox " />
                        <input
                          type="checkbox"
                          id="checkbox-7"
                          name="checkbox-7"
                          data-name="Checkbox 7"
                          style={{ opacity: 0, position: 'absolute', zIndex: -1 }}
                        />
                        <span className="w-form-label" htmlFor="checkbox-7">
                          Order Note
                        </span>
                      </label>
                    </div>
                  </form>
                  <div className="w-form-done">
                    <div>Thank you! Your submission has been received!</div>
                  </div>
                  <div className="w-form-fail">
                    <div>Oops! Something went wrong while submitting the form.</div>
                  </div>
                </div>
                <div className="container-info-filter bg">
                  <div className="icon small right-margin x2 w-embed">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="currentcolor"
                      viewBox="0 0 256 256"
                    >
                      <rect width="256" height="256" fill="none" />
                      <polyline
                        points="79.833 99.716 31.833 99.716 31.833 51.716"
                        fill="none"
                        stroke="currentcolor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="24"
                      />
                      <path
                        d="M65.7746,190.2254a88,88,0,1,0,0-124.4508L31.83348,99.71573"
                        fill="none"
                        stroke="currentcolor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="24"
                      />
                    </svg>
                  </div>
                  <div>Reset All</div>
                </div>
              </nav>
            </div>
            <div className="w-layout-grid grid-filters">
              <div
                data-hover="false"
                data-delay="0"
                id="w-node-eb08ab27-3ecd-1d2b-4d94-73f415ee89b3-b74eabf4"
                className="w-dropdown"
              >
                <div className="filter-select-field w-dropdown-toggle">
                  <div>Status</div>
                  <div className="icon-2 w-icon-dropdown-toggle " />
                </div>
                <nav className="dropdown-list w-dropdown-list">
                  <div className="form-block-filter w-form">
                    <form
                      id="email-form-3"
                      name="email-form-3"
                      data-name="Email Form 3"
                      method="get"
                      className="form-3"
                    >
                      <div className="div-block-45">
                        <label className="w-checkbox checkbox-field">
                          <div className="w-checkbox-input w-checkbox-input--inputType-custom checkbox " />
                          <input
                            type="checkbox"
                            id="checkbox-7"
                            name="checkbox-7"
                            data-name="Checkbox 7"
                            style={{ opacity: 0, position: 'absolute', zIndex: -1 }}
                          />
                          <span className="w-form-label" htmlFor="checkbox-7">
                            Open
                          </span>
                        </label>
                      </div>
                      <div className="div-block-45">
                        <label className="w-checkbox checkbox-field">
                          <div className="w-checkbox-input w-checkbox-input--inputType-custom checkbox " />
                          <input
                            type="checkbox"
                            id="checkbox-7"
                            name="checkbox-7"
                            data-name="Checkbox 7"
                            style={{ opacity: 0, position: 'absolute', zIndex: -1 }}
                          />
                          <span className="w-form-label" htmlFor="checkbox-7">
                            Paid
                          </span>
                        </label>
                      </div>
                      <div className="div-block-45">
                        <label className="w-checkbox checkbox-field">
                          <div className="w-checkbox-input w-checkbox-input--inputType-custom checkbox " />
                          <input
                            type="checkbox"
                            id="checkbox-7"
                            name="checkbox-7"
                            data-name="Checkbox 7"
                            style={{ opacity: 0, position: 'absolute', zIndex: -1 }}
                          />
                          <span className="w-form-label" htmlFor="checkbox-7">
                            In Production
                          </span>
                        </label>
                      </div>
                      <div className="div-block-45">
                        <label className="w-checkbox checkbox-field">
                          <div className="w-checkbox-input w-checkbox-input--inputType-custom checkbox " />
                          <input
                            type="checkbox"
                            id="checkbox-7"
                            name="checkbox-7"
                            data-name="Checkbox 7"
                            style={{ opacity: 0, position: 'absolute', zIndex: -1 }}
                          />
                          <span className="w-form-label" htmlFor="checkbox-7">
                            Cancelled
                          </span>
                        </label>
                      </div>
                      <div className="div-block-45">
                        <label className="w-checkbox checkbox-field">
                          <div className="w-checkbox-input w-checkbox-input--inputType-custom checkbox " />
                          <input
                            type="checkbox"
                            id="checkbox-7"
                            name="checkbox-7"
                            data-name="Checkbox 7"
                            style={{ opacity: 0, position: 'absolute', zIndex: -1 }}
                          />
                          <span className="w-form-label" htmlFor="checkbox-7">
                            Shipped
                          </span>
                        </label>
                      </div>
                      <div className="div-block-45">
                        <label className="w-checkbox checkbox-field">
                          <div className="w-checkbox-input w-checkbox-input--inputType-custom checkbox " />
                          <input
                            type="checkbox"
                            id="checkbox-7"
                            name="checkbox-7"
                            data-name="Checkbox 7"
                            style={{ opacity: 0, position: 'absolute', zIndex: -1 }}
                          />
                          <span className="w-form-label" htmlFor="checkbox-7">
                            On Hold
                          </span>
                        </label>
                      </div>
                      <div className="div-block-45">
                        <label className="w-checkbox checkbox-field">
                          <div className="w-checkbox-input w-checkbox-input--inputType-custom checkbox " />
                          <input
                            type="checkbox"
                            id="checkbox-7"
                            name="checkbox-7"
                            data-name="Checkbox 7"
                            style={{ opacity: 0, position: 'absolute', zIndex: -1 }}
                          />
                          <span className="w-form-label" htmlFor="checkbox-7">
                            Reprint
                          </span>
                        </label>
                      </div>
                    </form>
                    <div className="w-form-done">
                      <div>Thank you! Your submission has been received!</div>
                    </div>
                    <div className="w-form-fail">
                      <div>Oops! Something went wrong while submitting the form.</div>
                    </div>
                  </div>
                  <div className="container-info-filter bg">
                    <div className="icon small right-margin x2 w-embed">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="currentcolor"
                        viewBox="0 0 256 256"
                      >
                        <rect width="256" height="256" fill="none" />
                        <polyline
                          points="79.833 99.716 31.833 99.716 31.833 51.716"
                          fill="none"
                          stroke="currentcolor"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="24"
                        />
                        <path
                          d="M65.7746,190.2254a88,88,0,1,0,0-124.4508L31.83348,99.71573"
                          fill="none"
                          stroke="currentcolor"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="24"
                        />
                      </svg>
                    </div>
                    <div>Reset All</div>
                  </div>
                </nav>
              </div>
              <div className="grid-vertical-line " />
              <div data-hover="false" data-delay="0" className="w-dropdown">
                <div className="filter-select-field w-dropdown-toggle">
                  <div>Paper Type</div>
                  <div className="icon-2 w-icon-dropdown-toggle " />
                </div>
                <nav className="dropdown-list paper-type w-dropdown-list">
                  <div className="form-block-filter w-form">
                    <form
                      id="email-form-3"
                      name="email-form-3"
                      data-name="Email Form 3"
                      method="get"
                      className="form-3"
                    >
                      <div className="div-block-45">
                        <label className="w-checkbox checkbox-field">
                          <div className="w-checkbox-input w-checkbox-input--inputType-custom checkbox " />
                          <input
                            type="checkbox"
                            id="checkbox-7"
                            name="checkbox-7"
                            data-name="Checkbox 7"
                            style={{ opacity: 0, position: 'absolute', zIndex: -1 }}
                          />
                          <span className="w-form-label" htmlFor="checkbox-7">
                            Lustre
                          </span>
                        </label>
                        <div className="dot bigger paper">
                          <div>L</div>
                        </div>
                      </div>
                      <div className="div-block-45">
                        <label className="w-checkbox checkbox-field">
                          <div className="w-checkbox-input w-checkbox-input--inputType-custom checkbox " />
                          <input
                            type="checkbox"
                            id="checkbox-7"
                            name="checkbox-7"
                            data-name="Checkbox 7"
                            style={{ opacity: 0, position: 'absolute', zIndex: -1 }}
                          />
                          <span className="w-form-label" htmlFor="checkbox-7">
                            Satin
                          </span>
                        </label>
                        <div className="dot bigger paper">
                          <div>S</div>
                        </div>
                      </div>
                      <div className="div-block-45">
                        <label className="w-checkbox checkbox-field">
                          <div className="w-checkbox-input w-checkbox-input--inputType-custom checkbox " />
                          <input
                            type="checkbox"
                            id="checkbox-7"
                            name="checkbox-7"
                            data-name="Checkbox 7"
                            style={{ opacity: 0, position: 'absolute', zIndex: -1 }}
                          />
                          <span className="w-form-label" htmlFor="checkbox-7">
                            Photo Matte
                          </span>
                        </label>
                        <div className="dot bigger paper">
                          <div>PM</div>
                        </div>
                      </div>
                      <div className="div-block-45">
                        <label className="w-checkbox checkbox-field">
                          <div className="w-checkbox-input w-checkbox-input--inputType-custom checkbox " />
                          <input
                            type="checkbox"
                            id="checkbox-7"
                            name="checkbox-7"
                            data-name="Checkbox 7"
                            style={{ opacity: 0, position: 'absolute', zIndex: -1 }}
                          />
                          <span className="w-form-label" htmlFor="checkbox-7">
                            Ultra Smooth
                          </span>
                        </label>
                        <div className="dot bigger paper">
                          <div>US</div>
                        </div>
                      </div>
                      <div className="div-block-45">
                        <label className="w-checkbox checkbox-field">
                          <div className="w-checkbox-input w-checkbox-input--inputType-custom checkbox " />
                          <input
                            type="checkbox"
                            id="checkbox-7"
                            name="checkbox-7"
                            data-name="Checkbox 7"
                            style={{ opacity: 0, position: 'absolute', zIndex: -1 }}
                          />
                          <span className="w-form-label" htmlFor="checkbox-7">
                            Platine
                          </span>
                        </label>
                        <div className="dot bigger paper">
                          <div>PT</div>
                        </div>
                      </div>
                      <div className="div-block-45">
                        <label className="w-checkbox checkbox-field">
                          <div className="w-checkbox-input w-checkbox-input--inputType-custom checkbox " />
                          <input
                            type="checkbox"
                            id="checkbox-7"
                            name="checkbox-7"
                            data-name="Checkbox 7"
                            style={{ opacity: 0, position: 'absolute', zIndex: -1 }}
                          />
                          <span className="w-form-label" htmlFor="checkbox-7">
                            Canson Rag
                          </span>
                        </label>
                        <div className="dot bigger paper">
                          <div>CR</div>
                        </div>
                      </div>
                      <div className="div-block-45">
                        <label className="w-checkbox checkbox-field">
                          <div className="w-checkbox-input w-checkbox-input--inputType-custom checkbox " />
                          <input
                            type="checkbox"
                            id="checkbox-7"
                            name="checkbox-7"
                            data-name="Checkbox 7"
                            style={{ opacity: 0, position: 'absolute', zIndex: -1 }}
                          />
                          <span className="w-form-label" htmlFor="checkbox-7">
                            Museum Etching
                          </span>
                        </label>
                        <div className="dot bigger paper">
                          <div>ME</div>
                        </div>
                      </div>
                      <div className="div-block-45">
                        <label className="w-checkbox checkbox-field">
                          <div className="w-checkbox-input w-checkbox-input--inputType-custom checkbox " />
                          <input
                            type="checkbox"
                            id="checkbox-7"
                            name="checkbox-7"
                            data-name="Checkbox 7"
                            style={{ opacity: 0, position: 'absolute', zIndex: -1 }}
                          />
                          <span className="w-form-label" htmlFor="checkbox-7">
                            Deckled
                          </span>
                        </label>
                        <div className="dot bigger paper">
                          <div>DKL</div>
                        </div>
                      </div>
                    </form>
                    <div className="w-form-done">
                      <div>Thank you! Your submission has been received!</div>
                    </div>
                    <div className="w-form-fail">
                      <div>Oops! Something went wrong while submitting the form.</div>
                    </div>
                  </div>
                  <div className="container-info-filter bg">
                    <div className="icon small right-margin x2 w-embed">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="currentcolor"
                        viewBox="0 0 256 256"
                      >
                        <rect width="256" height="256" fill="none" />
                        <polyline
                          points="79.833 99.716 31.833 99.716 31.833 51.716"
                          fill="none"
                          stroke="currentcolor"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="24"
                        />
                        <path
                          d="M65.7746,190.2254a88,88,0,1,0,0-124.4508L31.83348,99.71573"
                          fill="none"
                          stroke="currentcolor"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="24"
                        />
                      </svg>
                    </div>
                    <div>Reset All</div>
                  </div>
                </nav>
              </div>
              <div className="grid-vertical-line " />
              <div data-hover="false" data-delay="0" className="w-dropdown">
                <div className="filter-select-field w-dropdown-toggle">
                  <div>Service</div>
                  <div className="icon-2 w-icon-dropdown-toggle " />
                </div>
                <nav className="dropdown-list service w-dropdown-list">
                  <div className="form-block-filter w-form">
                    <form
                      id="email-form-3"
                      name="email-form-3"
                      data-name="Email Form 3"
                      method="get"
                      className="form-3"
                    >
                      <div className="div-block-45">
                        <label className="w-checkbox checkbox-field">
                          <div className="w-checkbox-input w-checkbox-input--inputType-custom checkbox " />
                          <input
                            type="checkbox"
                            id="checkbox-7"
                            name="checkbox-7"
                            data-name="Checkbox 7"
                            style={{ opacity: 0, position: 'absolute', zIndex: -1 }}
                          />
                          <span className="w-form-label" htmlFor="checkbox-7">
                            Matting
                          </span>
                        </label>
                        <div className="dot bigger matting">
                          <div>MAT</div>
                        </div>
                      </div>
                      <div className="div-block-45">
                        <label className="w-checkbox checkbox-field">
                          <div className="w-checkbox-input w-checkbox-input--inputType-custom checkbox " />
                          <input
                            type="checkbox"
                            id="checkbox-7"
                            name="checkbox-7"
                            data-name="Checkbox 7"
                            style={{ opacity: 0, position: 'absolute', zIndex: -1 }}
                          />
                          <span className="w-form-label" htmlFor="checkbox-7">
                            Mounting
                          </span>
                        </label>
                        <div className="dot bigger mounting">
                          <div>MNT</div>
                        </div>
                      </div>
                      <div className="div-block-45">
                        <label className="w-checkbox checkbox-field">
                          <div className="w-checkbox-input w-checkbox-input--inputType-custom checkbox " />
                          <input
                            type="checkbox"
                            id="checkbox-7"
                            name="checkbox-7"
                            data-name="Checkbox 7"
                            style={{ opacity: 0, position: 'absolute', zIndex: -1 }}
                          />
                          <span className="w-form-label" htmlFor="checkbox-7">
                            Framing
                          </span>
                        </label>
                        <div className="dot bigger framing">
                          <div>FRM</div>
                        </div>
                      </div>
                      <div className="div-block-45">
                        <label className="w-checkbox checkbox-field">
                          <div className="w-checkbox-input w-checkbox-input--inputType-custom checkbox " />
                          <input
                            type="checkbox"
                            id="checkbox-7"
                            name="checkbox-7"
                            data-name="Checkbox 7"
                            style={{ opacity: 0, position: 'absolute', zIndex: -1 }}
                          />
                          <span className="w-form-label" htmlFor="checkbox-7">
                            Canvas
                          </span>
                        </label>
                        <div className="dot bigger canvas">
                          <div>CNV</div>
                        </div>
                      </div>
                      <div className="div-block-45">
                        <label className="w-checkbox checkbox-field">
                          <div className="w-checkbox-input w-checkbox-input--inputType-custom checkbox " />
                          <input
                            type="checkbox"
                            id="checkbox-7"
                            name="checkbox-7"
                            data-name="Checkbox 7"
                            style={{ opacity: 0, position: 'absolute', zIndex: -1 }}
                          />
                          <span className="w-form-label" htmlFor="checkbox-7">
                            API Orders
                          </span>
                        </label>
                        <div className="dot bigger api">
                          <div>API</div>
                        </div>
                      </div>
                      <div className="div-block-45">
                        <label className="w-checkbox checkbox-field">
                          <div className="w-checkbox-input w-checkbox-input--inputType-custom checkbox " />
                          <input
                            type="checkbox"
                            id="checkbox-7"
                            name="checkbox-7"
                            data-name="Checkbox 7"
                            style={{ opacity: 0, position: 'absolute', zIndex: -1 }}
                          />
                          <span className="w-form-label" htmlFor="checkbox-7">
                            Test Prints
                          </span>
                        </label>
                        <div className="dot bigger test-prints">
                          <div>TP</div>
                        </div>
                      </div>
                      <div className="div-block-45">
                        <label className="w-checkbox checkbox-field">
                          <div className="w-checkbox-input w-checkbox-input--inputType-custom checkbox " />
                          <input
                            type="checkbox"
                            id="checkbox-7"
                            name="checkbox-7"
                            data-name="Checkbox 7"
                            style={{ opacity: 0, position: 'absolute', zIndex: -1 }}
                          />
                          <span className="w-form-label" htmlFor="checkbox-7">
                            Boutique
                          </span>
                        </label>
                        <div className="dot bigger boutique">
                          <div>BTQ</div>
                        </div>
                      </div>
                      <div className="div-block-45">
                        <label className="w-checkbox checkbox-field">
                          <div className="w-checkbox-input w-checkbox-input--inputType-custom checkbox " />
                          <input
                            type="checkbox"
                            id="checkbox-7"
                            name="checkbox-7"
                            data-name="Checkbox 7"
                            style={{ opacity: 0, position: 'absolute', zIndex: -1 }}
                          />
                          <span className="w-form-label" htmlFor="checkbox-7">
                            Artist Proofs
                          </span>
                        </label>
                        <div className="dot bigger calibration">
                          <div>AP</div>
                        </div>
                      </div>
                    </form>
                    <div className="w-form-done">
                      <div>Thank you! Your submission has been received!</div>
                    </div>
                    <div className="w-form-fail">
                      <div>Oops! Something went wrong while submitting the form.</div>
                    </div>
                  </div>
                  <div className="container-info-filter bg">
                    <div className="icon small right-margin x2 w-embed">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="currentcolor"
                        viewBox="0 0 256 256"
                      >
                        <rect width="256" height="256" fill="none" />
                        <polyline
                          points="79.833 99.716 31.833 99.716 31.833 51.716"
                          fill="none"
                          stroke="currentcolor"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="24"
                        />
                        <path
                          d="M65.7746,190.2254a88,88,0,1,0,0-124.4508L31.83348,99.71573"
                          fill="none"
                          stroke="currentcolor"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="24"
                        />
                      </svg>
                    </div>
                    <div>Reset All</div>
                  </div>
                </nav>
              </div>
            </div>
          </div>
          <div
            id="w-node-_21a51873-c723-c389-9054-28e2e870526d-b74eabf4"
            className="form-block-18 w-form"
          >
            <form
              id="email-form-6"
              name="email-form-6"
              data-name="Email Form 6"
              method="get"
              className="form-11"
            >
              <div className="div-block-98">
                <label className="field-label-2">Line Item Status</label>
                <div className="div-block-99 bg">
                  <select
                    id="save"
                    name="field-3"
                    data-name="Field 3"
                    className="select-field-3-copy _2 w-select"
                  >
                    <option value="Another Choice">Choose One</option>
                    <option value="open">Printing</option>
                    <option value="paid">Matting</option>
                    <option value="shipped">Mounting</option>
                    <option value="in production">Framing</option>
                    <option value="Cancelled">Canvas Prod.</option>
                    <option value="on hold">Album Prod.</option>
                    <option value="Another Choice">Ready To Ship</option>
                    <option value="Another Choice">Shipped</option>
                    <option value="Another Choice">Reprint</option>
                    <option value="Another Choice">On Hold</option>
                    <option value="Another Choice">Cancelled</option>
                  </select>
                </div>
              </div>
              <a
                id="w-node-_21a51873-c723-c389-9054-28e2e870526f-b74eabf4"
                href="/lab-orders/unbundled-line-items"
                className="_2nd-button-2 main w-inline-block"
              >
                <div className="icon right-margin w-embed">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="currentcolor" viewBox="0 0 256 256">
                    <rect width="256" height="256" fill="none" />
                    <path d="M213.58936,82.2749,157.65723,26.34277c-.08008-.08007-.167-.15039-.25-.22656-.10791-.09912-.21289-.20166-.32618-.29492-.07519-.06152-.15576-.11524-.23291-.17432-.13085-.10009-.26025-.20166-.397-.29394-.062-.04151-.12793-.07617-.19043-.11573-.15869-.10009-.31738-.1997-.4834-.28906-.04492-.02392-.09179-.04248-.13672-.06543-.1875-.09668-.377-.18945-.57275-.271-.03027-.0127-.0625-.022-.09326-.03418-.21045-.08448-.42383-.16358-.64258-.23-.03174-.00977-.06445-.01563-.09619-.02491-.2168-.063-.436-.12109-.66064-.166-.07129-.01416-.145-.02051-.2168-.03272-.18555-.03222-.37012-.06494-.55908-.08349A7.91349,7.91349,0,0,0,152,24H55.99219a16.01833,16.01833,0,0,0-16,16V216a16.01833,16.01833,0,0,0,16,16H200a16.01833,16.01833,0,0,0,16-16V88.15479c.001-.05225.00781-.10254.00781-.15479A7.97147,7.97147,0,0,0,213.58936,82.2749Zm-51.93262,79.38233-28,28c-.023.02313-.04883.04223-.07178.06506-.165.16089-.33447.317-.51269.46326-.09766.08032-.20118.15039-.30176.22534-.1084.08111-.21485.1654-.32764.241-.11621.07794-.2373.1455-.35693.21667-.10449.06244-.20655.12817-.31446.18585-.12011.06439-.24414.119-.36669.17676-.11426.05389-.22657.1109-.34327.15942-.11816.049-.23925.08838-.35937.13135-.126.04541-.251.09387-.37988.133-.11963.03613-.24122.06262-.36231.09308-.13184.03338-.26269.07037-.397.097-.13965.02765-.28028.044-.42041.06415-.11817.01691-.23389.03925-.353.051C128.52686,191.986,128.26367,192,128,192s-.52686-.014-.78955-.03986c-.11914-.01171-.23486-.03405-.353-.051-.14013-.02014-.28076-.0365-.42041-.06415-.13428-.02667-.26513-.06366-.397-.097-.12109-.03046-.24268-.057-.36231-.09308-.1289-.03913-.2539-.08759-.37988-.133-.12012-.043-.24121-.0824-.35937-.13135-.1167-.04852-.229-.10553-.34327-.15942-.12255-.0578-.24658-.11237-.36669-.17676-.10791-.05768-.21-.12341-.31446-.18585-.11963-.07117-.24072-.13873-.35693-.21667-.11279-.07557-.21924-.15986-.32764-.241-.10058-.075-.2041-.145-.30176-.22534-.1748-.14374-.3413-.29718-.50341-.455-.02637-.02563-.05518-.04724-.08106-.0733l-28-28a8,8,0,0,1,11.31348-11.314L120,164.68652V120a8,8,0,0,1,16,0v44.68652l14.34326-14.34326a8,8,0,0,1,11.31348,11.314ZM152,88V43.31348L196.68555,88Z" />
                  </svg>
                </div>
                <div>Download All</div>
              </a>
            </form>
            <div className="w-form-done">
              <div>Thank you! Your submission has been received!</div>
            </div>
            <div className="w-form-fail">
              <div>Oops! Something went wrong while submitting the form.</div>
            </div>
          </div>
        </div>
      </div>
      <div className="wrapper">
        <div className="container-order-block">
          <div className="_3rd-block-container-order-copy unbundled-list">
            <div className="container-rightside-order-summary-copy">
              <div className="w-layout-grid grid-element-order-summary head unbundled-list">
                <div id="w-node-b85fc84a-7639-a916-6709-18ec67fd9a2a-b74eabf4" className="heady">
                  <div className="form-block-7 w-form">
                    <form
                      id="email-form-4"
                      name="email-form-4"
                      data-name="Email Form 4"
                      method="get"
                    >
                      <label className="w-checkbox checkbox-field-3">
                        <div className="w-checkbox-input w-checkbox-input--inputType-custom checkbox-4 _2 " />
                        <input
                          type="checkbox"
                          id="checkbox-8"
                          name="checkbox-8"
                          data-name="Checkbox 8"
                          style={{ opacity: 0, position: 'absolute', zIndex: -1 }}
                        />
                        <span className="checkbox-label-2 w-form-label" htmlFor="checkbox-8">
                          Checkbox 8
                        </span>
                      </label>
                    </form>
                    <div className="w-form-done">
                      <div>Thank you! Your submission has been received!</div>
                    </div>
                    <div className="w-form-fail">
                      <div>Oops! Something went wrong while submitting the form.</div>
                    </div>
                  </div>
                </div>
                <div id="w-node-_9159f475-e091-8ff7-5b5e-8b9da4b6c340-b74eabf4" className="heady">
                  <div className="div-block-353 " />
                </div>
                <div id="w-node-b5d27e99-ef88-6e89-7677-2535cf1f25a5-b74eabf4" className="heady">
                  <div>Image</div>
                </div>
                <div className="heady print-details">
                  <div>Print Details</div>
                </div>
                <div className="heady">
                  <div>Details</div>
                </div>
                <div className="heady">
                  <div>Notes</div>
                </div>
                <div id="w-node-_4ff616b2-037f-87d4-e48c-76a9c4e5c1fc-b74eabf4" className="heady">
                  <div>Qty</div>
                </div>
                <div id="w-node-f438072b-5987-7aab-1614-aedccca8dc6e-b74eabf4" className="heady">
                  <div>Total</div>
                </div>
                <div id="w-node-_9d421a0a-bed8-5014-abd0-b10e1e80fae3-b74eabf4" className="heady">
                  <div>Status</div>
                </div>
                <div id="w-node-_613a7126-eb2e-a6d5-cb97-a0b4b019691b-b74eabf4" className="heady">
                  <div className="icon w-embed">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="currentcolor"
                      viewBox="0 0 256 256"
                    >
                      <rect width="256" height="256" fill="none" />
                      <path d="M140,128a12,12,0,1,1-12-12A12,12,0,0,1,140,128Zm52-12a12,12,0,1,0,12,12A12,12,0,0,0,192,116ZM64,116a12,12,0,1,0,12,12A12,12,0,0,0,64,116Z" />
                    </svg>
                  </div>
                </div>
              </div>
              <div className="w-layout-grid grid-order-summary-container unbundled-list">
                <div
                  id="w-node-_3b5dcc35-7a3b-ad11-c48a-5bdf4f641014-b74eabf4"
                  className="w-layout-grid grid-element-order-summary unbundled-list"
                >
                  <div
                    id="w-node-_3b5dcc35-7a3b-ad11-c48a-5bdf4f641015-b74eabf4"
                    className="content"
                  >
                    <div className="form-block-7 w-form">
                      <form
                        id="email-form-4"
                        name="email-form-4"
                        data-name="Email Form 4"
                        method="get"
                      >
                        <label className="w-checkbox checkbox-field-3">
                          <div className="w-checkbox-input w-checkbox-input--inputType-custom checkbox-4 " />
                          <input
                            type="checkbox"
                            id="checkbox-8"
                            name="checkbox-8"
                            data-name="Checkbox 8"
                            style={{ opacity: 0, position: 'absolute', zIndex: -1 }}
                          />
                          <span className="checkbox-label-2 w-form-label" htmlFor="checkbox-8">
                            Checkbox 8
                          </span>
                        </label>
                      </form>
                      <div className="w-form-done">
                        <div>Thank you! Your submission has been received!</div>
                      </div>
                      <div className="w-form-fail">
                        <div>Oops! Something went wrong while submitting the form.</div>
                      </div>
                    </div>
                  </div>
                  <div
                    id="w-node-_3b5dcc35-7a3b-ad11-c48a-5bdf4f641022-b74eabf4"
                    className="content"
                  >
                    <div className="w-layout-grid grid-90">
                      <div data-tippy-content="mounting" className="dot bigger mounting tippy">
                        <div>MNT</div>
                      </div>
                      <div className="dot bigger paper">
                        <div>PM</div>
                      </div>
                    </div>
                  </div>
                  <div
                    id="w-node-_3b5dcc35-7a3b-ad11-c48a-5bdf4f64102a-b74eabf4"
                    className="content"
                  >
                    <div className="div-block-136">
                      <a
                        href="/lab-orders/unbundled-line-items"
                        aria-label="Unbundled Line Items Link"
                        className="w-inline-block w-lightbox"
                      >
                        <img
                          src="images/default-placeholder.jpg"
                          loading="lazy"
                          srcSet="images/default-placeholder-p-500.jpeg 500w, images/default-placeholder-p-800.jpeg 800w, images/default-placeholder-p-1080.jpeg 1080w, images/default-placeholder.jpg 1500w"
                          sizes="(max-width: 479px) 50px, (max-width: 1279px) 80px, 90px"
                          alt=""
                          className="img-order-summary bigger"
                        />
                      </a>
                    </div>
                  </div>
                  <div className="content print-details unbundled-list">
                    <div className="div-block-350">
                      <div className="grey darker">&quot;Sample&quot;</div>
                      <div>Canson Rag 8x8</div>
                      <div className="w-layout-grid grid-23 main align-left">
                        <div className="icon smaller w-embed">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="currentcolor"
                            viewBox="0 0 256 256"
                          >
                            <rect width="256" height="256" fill="none" />
                            <path d="M209.65479,122.3418a8,8,0,0,1-.00733,11.31347l-82.05322,81.94629a56.00006,56.00006,0,0,1-79.1919-79.20019L147.6709,35.751A39.99954,39.99954,0,1,1,204.27832,92.2793l-99.269,100.65136A23.99954,23.99954,0,1,1,71.02979,159.0293L154.291,74.38477a8.0001,8.0001,0,0,1,11.40625,11.2207L82.38965,170.29688a8,8,0,1,0,11.2666,11.36035L192.92578,81.00488a23.99971,23.99971,0,1,0-33.90185-33.97949L59.75488,147.67578a40.00024,40.00024,0,1,0,56.5293,56.6084L198.34082,122.335A7.99885,7.99885,0,0,1,209.65479,122.3418Z" />
                          </svg>
                        </div>
                        <div>name-file.jpg</div>
                      </div>
                      <a href="admin-order-details.html" className="link-block-12 w-inline-block">
                        <div className="w-layout-grid grid-23 main no-padding">
                          <div>MUS-123XYZ</div>
                          <div className="icon smaller w-embed">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              fill="currentcolor"
                              viewBox="0 0 256 256"
                            >
                              <rect width="256" height="256" fill="none" />
                              <line
                                x1="64"
                                y1="192"
                                x2="192"
                                y2="64"
                                fill="none"
                                stroke="currentcolor"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="16"
                              />
                              <polyline
                                points="88 64 192 64 192 168"
                                fill="none"
                                stroke="currentcolor"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="16"
                              />
                            </svg>
                          </div>
                        </div>
                      </a>
                    </div>
                  </div>
                  <div className="content">
                    <div className="text-table-top-container">
                      <div className="text-table _12px semi-bold">Venetian Silver</div>
                      <div className="text-table _12px semi-bold">2&quot; Mat</div>
                      <div className="text-table _12px semi-bold">Standard Acrylic</div>
                    </div>
                  </div>
                  <div className="content">
                    <div className="div-block-357-copy">
                      <div id="text-table" className="text-table smaller red">
                        Completely transform pandemic information via cross functional systems.
                        Proactively harness.
                      </div>
                      <div id="delete" className="w-layout-grid top-buttons-image-element z-index">
                        <div
                          data-w-id="3b5dcc35-7a3b-ad11-c48a-5bdf4f64104a"
                          className="delete-symbol no-margin"
                        >
                          <div className="icon smaller w-embed">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              fill="currentcolor"
                              viewBox="0 0 256 256"
                            >
                              <rect width="256" height="256" fill="none" />
                              <path d="M216,208H115.314l82.33838-82.33887.00489-.00439.00439-.00488L223.999,99.31445A15.99888,15.99888,0,0,0,224,76.68652L179.31348,31.999A16.02162,16.02162,0,0,0,156.68555,32l-120,120.00049a15.95392,15.95392,0,0,0-3.572,5.45654c-.08228.19971-.15162.40283-.21705.60742A15.9896,15.9896,0,0,0,32,163.31348V208a16.01833,16.01833,0,0,0,16,16H216a8,8,0,0,0,0-16ZM168,43.31348,212.68555,88,192,108.68555,147.314,64Z" />
                            </svg>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="w-layout-grid grid-93">
                      <div
                        data-w-id="3b5dcc35-7a3b-ad11-c48a-5bdf4f64104d"
                        className="note-tooltip"
                      >
                        <div className="icon small x2 w-embed">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="currentcolor"
                            viewBox="0 0 256 256"
                          >
                            <rect width="256" height="256" fill="none" />
                            <path d="M208,32H48A16.01081,16.01081,0,0,0,32,48V208a16.01081,16.01081,0,0,0,16,16H156.6875A15.92313,15.92313,0,0,0,168,219.3125L219.3125,168A15.92313,15.92313,0,0,0,224,156.6875V48A16.01081,16.01081,0,0,0,208,32ZM96,88h64a8,8,0,0,1,0,16H96a8,8,0,0,1,0-16Zm32,80H96a8,8,0,0,1,0-16h32a8,8,0,0,1,0,16ZM96,136a8,8,0,0,1,0-16h64a8,8,0,0,1,0,16Zm64,68.6875V159.98438h44.70312Z" />
                          </svg>
                        </div>
                        <div className="div-block-354">
                          <div>C</div>
                        </div>
                        <div style={{ opacity: 0 }} className="client-note">
                          <div className="note-tooltip-wrapper">
                            <div className="div-block-356" />
                            <div className="div-block-357">
                              <div>Client Note:</div>
                              <div id="text-table" className="text-table smaller red">
                                Completely transform pandemic information via cross functional
                                systems. Proactively harness.
                              </div>
                              <div className="line-bottom-note-container " />
                              <div
                                id="delete"
                                className="w-layout-grid top-buttons-image-element z-index"
                              >
                                <div
                                  data-w-id="3b5dcc35-7a3b-ad11-c48a-5bdf4f64105c"
                                  className="delete-symbol"
                                >
                                  <div className="icon smaller w-embed">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      fill="currentcolor"
                                      viewBox="0 0 256 256"
                                    >
                                      <rect width="256" height="256" fill="none" />
                                      <path d="M216,208H115.314l82.33838-82.33887.00489-.00439.00439-.00488L223.999,99.31445A15.99888,15.99888,0,0,0,224,76.68652L179.31348,31.999A16.02162,16.02162,0,0,0,156.68555,32l-120,120.00049a15.95392,15.95392,0,0,0-3.572,5.45654c-.08228.19971-.15162.40283-.21705.60742A15.9896,15.9896,0,0,0,32,163.31348V208a16.01833,16.01833,0,0,0,16,16H216a8,8,0,0,0,0-16ZM168,43.31348,212.68555,88,192,108.68555,147.314,64Z" />
                                    </svg>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        data-w-id="3b5dcc35-7a3b-ad11-c48a-5bdf4f64105e"
                        className="note-tooltip admin"
                      >
                        <div className="icon small x2 w-embed">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="currentcolor"
                            viewBox="0 0 256 256"
                          >
                            <rect width="256" height="256" fill="none" />
                            <path d="M208,32H48A16.01081,16.01081,0,0,0,32,48V208a16.01081,16.01081,0,0,0,16,16H156.6875A15.92313,15.92313,0,0,0,168,219.3125L219.3125,168A15.92313,15.92313,0,0,0,224,156.6875V48A16.01081,16.01081,0,0,0,208,32ZM96,88h64a8,8,0,0,1,0,16H96a8,8,0,0,1,0-16Zm32,80H96a8,8,0,0,1,0-16h32a8,8,0,0,1,0,16ZM96,136a8,8,0,0,1,0-16h64a8,8,0,0,1,0,16Zm64,68.6875V159.98438h44.70312Z" />
                          </svg>
                        </div>
                        <div className="div-block-354 admin">
                          <div>A</div>
                        </div>
                        <div style={{ opacity: 0 }} className="client-note">
                          <div className="note-tooltip-wrapper">
                            <div className="div-block-356" />
                            <div className="div-block-357">
                              <div>Admin Note:</div>
                              <div id="text-table" className="text-table smaller">
                                Completely transform pandemic information via cross functional
                                systems. Proactively harness.
                              </div>
                              <div className="line-bottom-note-container admin " />
                              <div
                                id="delete"
                                className="w-layout-grid top-buttons-image-element z-index"
                              >
                                <div
                                  data-w-id="3b5dcc35-7a3b-ad11-c48a-5bdf4f64106d"
                                  className="delete-symbol"
                                >
                                  <div className="icon smaller w-embed">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      fill="currentcolor"
                                      viewBox="0 0 256 256"
                                    >
                                      <rect width="256" height="256" fill="none" />
                                      <path d="M216,208H115.314l82.33838-82.33887.00489-.00439.00439-.00488L223.999,99.31445A15.99888,15.99888,0,0,0,224,76.68652L179.31348,31.999A16.02162,16.02162,0,0,0,156.68555,32l-120,120.00049a15.95392,15.95392,0,0,0-3.572,5.45654c-.08228.19971-.15162.40283-.21705.60742A15.9896,15.9896,0,0,0,32,163.31348V208a16.01833,16.01833,0,0,0,16,16H216a8,8,0,0,0,0-16ZM168,43.31348,212.68555,88,192,108.68555,147.314,64Z" />
                                    </svg>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        data-w-id="3b5dcc35-7a3b-ad11-c48a-5bdf4f64106f"
                        className="note-tooltip boutique"
                      >
                        <div className="icon small x2 w-embed">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="currentcolor"
                            viewBox="0 0 256 256"
                          >
                            <rect width="256" height="256" fill="none" />
                            <path d="M208,32H48A16.01081,16.01081,0,0,0,32,48V208a16.01081,16.01081,0,0,0,16,16H156.6875A15.92313,15.92313,0,0,0,168,219.3125L219.3125,168A15.92313,15.92313,0,0,0,224,156.6875V48A16.01081,16.01081,0,0,0,208,32ZM96,88h64a8,8,0,0,1,0,16H96a8,8,0,0,1,0-16Zm32,80H96a8,8,0,0,1,0-16h32a8,8,0,0,1,0,16ZM96,136a8,8,0,0,1,0-16h64a8,8,0,0,1,0,16Zm64,68.6875V159.98438h44.70312Z" />
                          </svg>
                        </div>
                        <div className="div-block-354 boutique">
                          <div>B</div>
                        </div>
                        <div style={{ opacity: 0 }} className="client-note">
                          <div className="note-tooltip-wrapper">
                            <div className="div-block-356" />
                            <div className="div-block-357">
                              <div>Boutique Note:</div>
                              <div id="text-table" className="text-table smaller">
                                Completely transform pandemic information via cross functional
                                systems. Proactively harness.
                              </div>
                              <div className="line-bottom-note-container boutique " />
                              <div
                                id="delete"
                                className="w-layout-grid top-buttons-image-element z-index"
                              >
                                <div
                                  data-w-id="3b5dcc35-7a3b-ad11-c48a-5bdf4f64107e"
                                  className="delete-symbol"
                                >
                                  <div className="icon smaller w-embed">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      fill="currentcolor"
                                      viewBox="0 0 256 256"
                                    >
                                      <rect width="256" height="256" fill="none" />
                                      <path d="M216,208H115.314l82.33838-82.33887.00489-.00439.00439-.00488L223.999,99.31445A15.99888,15.99888,0,0,0,224,76.68652L179.31348,31.999A16.02162,16.02162,0,0,0,156.68555,32l-120,120.00049a15.95392,15.95392,0,0,0-3.572,5.45654c-.08228.19971-.15162.40283-.21705.60742A15.9896,15.9896,0,0,0,32,163.31348V208a16.01833,16.01833,0,0,0,16,16H216a8,8,0,0,0,0-16ZM168,43.31348,212.68555,88,192,108.68555,147.314,64Z" />
                                    </svg>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    id="w-node-_3b5dcc35-7a3b-ad11-c48a-5bdf4f641080-b74eabf4"
                    className="content"
                  >
                    <div className="text-table red">04</div>
                  </div>
                  <div
                    id="w-node-_3b5dcc35-7a3b-ad11-c48a-5bdf4f641083-b74eabf4"
                    className="content"
                  >
                    <div className="text-table price">$ 30.00</div>
                  </div>
                  <div
                    id="w-node-_3b5dcc35-7a3b-ad11-c48a-5bdf4f641086-b74eabf4"
                    className="content"
                  >
                    <div className="form-block-input w-form">
                      <form
                        id="email-form"
                        name="email-form"
                        data-name="Email Form"
                        method="get"
                        className="form-input select-field"
                      >
                        <div className="select-field-wrapper">
                          <select
                            id="save"
                            name="field-3"
                            data-name="Field 3"
                            className="form-select-field w-select"
                          >
                            <option value="open">Printing</option>
                            <option value="paid">Matting</option>
                            <option value="shipped">Mounting</option>
                            <option value="in production">Framing</option>
                            <option value="Cancelled">Canvas Prod.</option>
                            <option value="on hold">Album Prod.</option>
                            <option value="Another Choice">Ready To Ship</option>
                            <option value="Another Choice">Shipped</option>
                            <option value="Another Choice">Reprint</option>
                            <option value="Another Choice">On Hold</option>
                            <option value="Another Choice">Cancelled</option>
                          </select>
                          <div className="div-block-63">
                            <img
                              src="images/chevron-down-12.svg"
                              loading="lazy"
                              alt=""
                              className="img-icon"
                            />
                          </div>
                        </div>
                      </form>
                      <div className="w-form-done">
                        <div>Thank you! Your submission has been received!</div>
                      </div>
                      <div className="w-form-fail">
                        <div>Oops! Something went wrong while submitting the form.</div>
                      </div>
                    </div>
                  </div>
                  <div
                    id="w-node-_3b5dcc35-7a3b-ad11-c48a-5bdf4f641094-b74eabf4"
                    className="content"
                  >
                    <a
                      href="/lab-orders/unbundled-line-items"
                      aria-label="Unbundled Line Items Link"
                      className="link-block-11 w-inline-block"
                    >
                      <div className="icon w-embed">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="currentcolor"
                          viewBox="0 0 256 256"
                        >
                          <rect width="256" height="256" fill="none" />
                          <path d="M213.58936,82.2749,157.65723,26.34277c-.08008-.08007-.167-.15039-.25-.22656-.10791-.09912-.21289-.20166-.32618-.29492-.07519-.06152-.15576-.11524-.23291-.17432-.13085-.10009-.26025-.20166-.397-.29394-.062-.04151-.12793-.07617-.19043-.11573-.15869-.10009-.31738-.1997-.4834-.28906-.04492-.02392-.09179-.04248-.13672-.06543-.1875-.09668-.377-.18945-.57275-.271-.03027-.0127-.0625-.022-.09326-.03418-.21045-.08448-.42383-.16358-.64258-.23-.03174-.00977-.06445-.01563-.09619-.02491-.2168-.063-.436-.12109-.66064-.166-.07129-.01416-.145-.02051-.2168-.03272-.18555-.03222-.37012-.06494-.55908-.08349A7.91349,7.91349,0,0,0,152,24H55.99219a16.01833,16.01833,0,0,0-16,16V216a16.01833,16.01833,0,0,0,16,16H200a16.01833,16.01833,0,0,0,16-16V88.15479c.001-.05225.00781-.10254.00781-.15479A7.97147,7.97147,0,0,0,213.58936,82.2749Zm-51.93262,79.38233-28,28c-.023.02313-.04883.04223-.07178.06506-.165.16089-.33447.317-.51269.46326-.09766.08032-.20118.15039-.30176.22534-.1084.08111-.21485.1654-.32764.241-.11621.07794-.2373.1455-.35693.21667-.10449.06244-.20655.12817-.31446.18585-.12011.06439-.24414.119-.36669.17676-.11426.05389-.22657.1109-.34327.15942-.11816.049-.23925.08838-.35937.13135-.126.04541-.251.09387-.37988.133-.11963.03613-.24122.06262-.36231.09308-.13184.03338-.26269.07037-.397.097-.13965.02765-.28028.044-.42041.06415-.11817.01691-.23389.03925-.353.051C128.52686,191.986,128.26367,192,128,192s-.52686-.014-.78955-.03986c-.11914-.01171-.23486-.03405-.353-.051-.14013-.02014-.28076-.0365-.42041-.06415-.13428-.02667-.26513-.06366-.397-.097-.12109-.03046-.24268-.057-.36231-.09308-.1289-.03913-.2539-.08759-.37988-.133-.12012-.043-.24121-.0824-.35937-.13135-.1167-.04852-.229-.10553-.34327-.15942-.12255-.0578-.24658-.11237-.36669-.17676-.10791-.05768-.21-.12341-.31446-.18585-.11963-.07117-.24072-.13873-.35693-.21667-.11279-.07557-.21924-.15986-.32764-.241-.10058-.075-.2041-.145-.30176-.22534-.1748-.14374-.3413-.29718-.50341-.455-.02637-.02563-.05518-.04724-.08106-.0733l-28-28a8,8,0,0,1,11.31348-11.314L120,164.68652V120a8,8,0,0,1,16,0v44.68652l14.34326-14.34326a8,8,0,0,1,11.31348,11.314ZM152,88V43.31348L196.68555,88Z" />
                        </svg>
                      </div>
                    </a>
                  </div>
                </div>
                <div
                  id="w-node-_50d52765-6c57-ce26-b7f8-0fbbf8674f58-b74eabf4"
                  className="w-layout-grid grid-element-order-summary unbundled-list"
                >
                  <div
                    id="w-node-_50d52765-6c57-ce26-b7f8-0fbbf8674f59-b74eabf4"
                    className="content"
                  >
                    <div className="form-block-7 w-form">
                      <form
                        id="email-form-4"
                        name="email-form-4"
                        data-name="Email Form 4"
                        method="get"
                      >
                        <label className="w-checkbox checkbox-field-3">
                          <div className="w-checkbox-input w-checkbox-input--inputType-custom checkbox-4 " />
                          <input
                            type="checkbox"
                            id="checkbox-8"
                            name="checkbox-8"
                            data-name="Checkbox 8"
                            style={{ opacity: 0, position: 'absolute', zIndex: -1 }}
                          />
                          <span className="checkbox-label-2 w-form-label" htmlFor="checkbox-8">
                            Checkbox 8
                          </span>
                        </label>
                      </form>
                      <div className="w-form-done">
                        <div>Thank you! Your submission has been received!</div>
                      </div>
                      <div className="w-form-fail">
                        <div>Oops! Something went wrong while submitting the form.</div>
                      </div>
                    </div>
                  </div>
                  <div
                    id="w-node-_50d52765-6c57-ce26-b7f8-0fbbf8674f66-b74eabf4"
                    className="content"
                  >
                    <div className="w-layout-grid grid-90">
                      <div data-tippy-content="mounting" className="dot bigger mounting tippy">
                        <div>MNT</div>
                      </div>
                      <div className="dot bigger paper">
                        <div>PM</div>
                      </div>
                    </div>
                  </div>
                  <div
                    id="w-node-_50d52765-6c57-ce26-b7f8-0fbbf8674f6e-b74eabf4"
                    className="content"
                  >
                    <div className="div-block-136">
                      <a
                        href="/lab-orders/unbundled-line-items"
                        aria-label="Unbundled Line Items Link"
                        className="w-inline-block w-lightbox"
                      >
                        <img
                          src="images/default-placeholder.jpg"
                          loading="lazy"
                          srcSet="images/default-placeholder-p-500.jpeg 500w, images/default-placeholder-p-800.jpeg 800w, images/default-placeholder-p-1080.jpeg 1080w, images/default-placeholder.jpg 1500w"
                          sizes="(max-width: 479px) 50px, (max-width: 1279px) 80px, 90px"
                          alt=""
                          className="img-order-summary bigger"
                        />
                      </a>
                    </div>
                  </div>
                  <div className="content print-details unbundled-list">
                    <div className="div-block-350">
                      <div className="grey darker">&quot;Sample&quot;</div>
                      <div>Canson Rag 8x8</div>
                      <div className="w-layout-grid grid-23 main align-left">
                        <div className="icon smaller w-embed">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="currentcolor"
                            viewBox="0 0 256 256"
                          >
                            <rect width="256" height="256" fill="none" />
                            <path d="M209.65479,122.3418a8,8,0,0,1-.00733,11.31347l-82.05322,81.94629a56.00006,56.00006,0,0,1-79.1919-79.20019L147.6709,35.751A39.99954,39.99954,0,1,1,204.27832,92.2793l-99.269,100.65136A23.99954,23.99954,0,1,1,71.02979,159.0293L154.291,74.38477a8.0001,8.0001,0,0,1,11.40625,11.2207L82.38965,170.29688a8,8,0,1,0,11.2666,11.36035L192.92578,81.00488a23.99971,23.99971,0,1,0-33.90185-33.97949L59.75488,147.67578a40.00024,40.00024,0,1,0,56.5293,56.6084L198.34082,122.335A7.99885,7.99885,0,0,1,209.65479,122.3418Z" />
                          </svg>
                        </div>
                        <div>name-file.jpg</div>
                      </div>
                      <a href="admin-order-details.html" className="link-block-12 w-inline-block">
                        <div className="w-layout-grid grid-23 main no-padding">
                          <div>MUS-123XYZ</div>
                          <div className="icon smaller w-embed">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              fill="currentcolor"
                              viewBox="0 0 256 256"
                            >
                              <rect width="256" height="256" fill="none" />
                              <line
                                x1="64"
                                y1="192"
                                x2="192"
                                y2="64"
                                fill="none"
                                stroke="currentcolor"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="16"
                              />
                              <polyline
                                points="88 64 192 64 192 168"
                                fill="none"
                                stroke="currentcolor"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="16"
                              />
                            </svg>
                          </div>
                        </div>
                      </a>
                    </div>
                  </div>
                  <div className="content">
                    <div className="text-table-top-container">
                      <div className="text-table _12px semi-bold">Venetian Silver</div>
                      <div className="text-table _12px semi-bold">2&quot; Mat</div>
                      <div className="text-table _12px semi-bold">Standard Acrylic</div>
                    </div>
                  </div>
                  <div className="content">
                    <div className="div-block-357-copy">
                      <div id="text-table" className="text-table smaller red">
                        Completely transform pandemic information via cross functional systems.
                        Proactively harness.
                      </div>
                      <div id="delete" className="w-layout-grid top-buttons-image-element z-index">
                        <div
                          data-w-id="50d52765-6c57-ce26-b7f8-0fbbf8674f8e"
                          className="delete-symbol no-margin"
                        >
                          <div className="icon smaller w-embed">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              fill="currentcolor"
                              viewBox="0 0 256 256"
                            >
                              <rect width="256" height="256" fill="none" />
                              <path d="M216,208H115.314l82.33838-82.33887.00489-.00439.00439-.00488L223.999,99.31445A15.99888,15.99888,0,0,0,224,76.68652L179.31348,31.999A16.02162,16.02162,0,0,0,156.68555,32l-120,120.00049a15.95392,15.95392,0,0,0-3.572,5.45654c-.08228.19971-.15162.40283-.21705.60742A15.9896,15.9896,0,0,0,32,163.31348V208a16.01833,16.01833,0,0,0,16,16H216a8,8,0,0,0,0-16ZM168,43.31348,212.68555,88,192,108.68555,147.314,64Z" />
                            </svg>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="w-layout-grid grid-93">
                      <div
                        data-w-id="50d52765-6c57-ce26-b7f8-0fbbf8674f91"
                        className="note-tooltip"
                      >
                        <div className="icon small x2 w-embed">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="currentcolor"
                            viewBox="0 0 256 256"
                          >
                            <rect width="256" height="256" fill="none" />
                            <path d="M208,32H48A16.01081,16.01081,0,0,0,32,48V208a16.01081,16.01081,0,0,0,16,16H156.6875A15.92313,15.92313,0,0,0,168,219.3125L219.3125,168A15.92313,15.92313,0,0,0,224,156.6875V48A16.01081,16.01081,0,0,0,208,32ZM96,88h64a8,8,0,0,1,0,16H96a8,8,0,0,1,0-16Zm32,80H96a8,8,0,0,1,0-16h32a8,8,0,0,1,0,16ZM96,136a8,8,0,0,1,0-16h64a8,8,0,0,1,0,16Zm64,68.6875V159.98438h44.70312Z" />
                          </svg>
                        </div>
                        <div className="div-block-354">
                          <div>C</div>
                        </div>
                        <div style={{ opacity: 0 }} className="client-note">
                          <div className="note-tooltip-wrapper">
                            <div className="div-block-356" />
                            <div className="div-block-357">
                              <div>Client Note:</div>
                              <div id="text-table" className="text-table smaller red">
                                Completely transform pandemic information via cross functional
                                systems. Proactively harness.
                              </div>
                              <div className="line-bottom-note-container " />
                              <div
                                id="delete"
                                className="w-layout-grid top-buttons-image-element z-index"
                              >
                                <div
                                  data-w-id="50d52765-6c57-ce26-b7f8-0fbbf8674fa0"
                                  className="delete-symbol"
                                >
                                  <div className="icon smaller w-embed">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      fill="currentcolor"
                                      viewBox="0 0 256 256"
                                    >
                                      <rect width="256" height="256" fill="none" />
                                      <path d="M216,208H115.314l82.33838-82.33887.00489-.00439.00439-.00488L223.999,99.31445A15.99888,15.99888,0,0,0,224,76.68652L179.31348,31.999A16.02162,16.02162,0,0,0,156.68555,32l-120,120.00049a15.95392,15.95392,0,0,0-3.572,5.45654c-.08228.19971-.15162.40283-.21705.60742A15.9896,15.9896,0,0,0,32,163.31348V208a16.01833,16.01833,0,0,0,16,16H216a8,8,0,0,0,0-16ZM168,43.31348,212.68555,88,192,108.68555,147.314,64Z" />
                                    </svg>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        data-w-id="50d52765-6c57-ce26-b7f8-0fbbf8674fa2"
                        className="note-tooltip admin"
                      >
                        <div className="icon small x2 w-embed">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="currentcolor"
                            viewBox="0 0 256 256"
                          >
                            <rect width="256" height="256" fill="none" />
                            <path d="M208,32H48A16.01081,16.01081,0,0,0,32,48V208a16.01081,16.01081,0,0,0,16,16H156.6875A15.92313,15.92313,0,0,0,168,219.3125L219.3125,168A15.92313,15.92313,0,0,0,224,156.6875V48A16.01081,16.01081,0,0,0,208,32ZM96,88h64a8,8,0,0,1,0,16H96a8,8,0,0,1,0-16Zm32,80H96a8,8,0,0,1,0-16h32a8,8,0,0,1,0,16ZM96,136a8,8,0,0,1,0-16h64a8,8,0,0,1,0,16Zm64,68.6875V159.98438h44.70312Z" />
                          </svg>
                        </div>
                        <div className="div-block-354 admin">
                          <div>A</div>
                        </div>
                        <div style={{ opacity: 0 }} className="client-note">
                          <div className="note-tooltip-wrapper">
                            <div className="div-block-356" />
                            <div className="div-block-357">
                              <div>Admin Note:</div>
                              <div id="text-table" className="text-table smaller">
                                Completely transform pandemic information via cross functional
                                systems. Proactively harness.
                              </div>
                              <div className="line-bottom-note-container admin " />
                              <div
                                id="delete"
                                className="w-layout-grid top-buttons-image-element z-index"
                              >
                                <div
                                  data-w-id="50d52765-6c57-ce26-b7f8-0fbbf8674fb1"
                                  className="delete-symbol"
                                >
                                  <div className="icon smaller w-embed">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      fill="currentcolor"
                                      viewBox="0 0 256 256"
                                    >
                                      <rect width="256" height="256" fill="none" />
                                      <path d="M216,208H115.314l82.33838-82.33887.00489-.00439.00439-.00488L223.999,99.31445A15.99888,15.99888,0,0,0,224,76.68652L179.31348,31.999A16.02162,16.02162,0,0,0,156.68555,32l-120,120.00049a15.95392,15.95392,0,0,0-3.572,5.45654c-.08228.19971-.15162.40283-.21705.60742A15.9896,15.9896,0,0,0,32,163.31348V208a16.01833,16.01833,0,0,0,16,16H216a8,8,0,0,0,0-16ZM168,43.31348,212.68555,88,192,108.68555,147.314,64Z" />
                                    </svg>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        data-w-id="50d52765-6c57-ce26-b7f8-0fbbf8674fb3"
                        className="note-tooltip boutique"
                      >
                        <div className="icon small x2 w-embed">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="currentcolor"
                            viewBox="0 0 256 256"
                          >
                            <rect width="256" height="256" fill="none" />
                            <path d="M208,32H48A16.01081,16.01081,0,0,0,32,48V208a16.01081,16.01081,0,0,0,16,16H156.6875A15.92313,15.92313,0,0,0,168,219.3125L219.3125,168A15.92313,15.92313,0,0,0,224,156.6875V48A16.01081,16.01081,0,0,0,208,32ZM96,88h64a8,8,0,0,1,0,16H96a8,8,0,0,1,0-16Zm32,80H96a8,8,0,0,1,0-16h32a8,8,0,0,1,0,16ZM96,136a8,8,0,0,1,0-16h64a8,8,0,0,1,0,16Zm64,68.6875V159.98438h44.70312Z" />
                          </svg>
                        </div>
                        <div className="div-block-354 boutique">
                          <div>B</div>
                        </div>
                        <div style={{ opacity: 0 }} className="client-note">
                          <div className="note-tooltip-wrapper">
                            <div className="div-block-356" />
                            <div className="div-block-357">
                              <div>Boutique Note:</div>
                              <div id="text-table" className="text-table smaller">
                                Completely transform pandemic information via cross functional
                                systems. Proactively harness.
                              </div>
                              <div className="line-bottom-note-container boutique " />
                              <div
                                id="delete"
                                className="w-layout-grid top-buttons-image-element z-index"
                              >
                                <div
                                  data-w-id="50d52765-6c57-ce26-b7f8-0fbbf8674fc2"
                                  className="delete-symbol"
                                >
                                  <div className="icon smaller w-embed">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      fill="currentcolor"
                                      viewBox="0 0 256 256"
                                    >
                                      <rect width="256" height="256" fill="none" />
                                      <path d="M216,208H115.314l82.33838-82.33887.00489-.00439.00439-.00488L223.999,99.31445A15.99888,15.99888,0,0,0,224,76.68652L179.31348,31.999A16.02162,16.02162,0,0,0,156.68555,32l-120,120.00049a15.95392,15.95392,0,0,0-3.572,5.45654c-.08228.19971-.15162.40283-.21705.60742A15.9896,15.9896,0,0,0,32,163.31348V208a16.01833,16.01833,0,0,0,16,16H216a8,8,0,0,0,0-16ZM168,43.31348,212.68555,88,192,108.68555,147.314,64Z" />
                                    </svg>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    id="w-node-_50d52765-6c57-ce26-b7f8-0fbbf8674fc4-b74eabf4"
                    className="content"
                  >
                    <div className="text-table red">04</div>
                  </div>
                  <div
                    id="w-node-_50d52765-6c57-ce26-b7f8-0fbbf8674fc7-b74eabf4"
                    className="content"
                  >
                    <div className="text-table price">$ 30.00</div>
                  </div>
                  <div
                    id="w-node-_50d52765-6c57-ce26-b7f8-0fbbf8674fca-b74eabf4"
                    className="content"
                  >
                    <div className="form-block-input w-form">
                      <form
                        id="email-form"
                        name="email-form"
                        data-name="Email Form"
                        method="get"
                        className="form-input select-field"
                      >
                        <div className="select-field-wrapper">
                          <select
                            id="save"
                            name="field-3"
                            data-name="Field 3"
                            className="form-select-field w-select"
                          >
                            <option value="open">Printing</option>
                            <option value="paid">Matting</option>
                            <option value="shipped">Mounting</option>
                            <option value="in production">Framing</option>
                            <option value="Cancelled">Canvas Prod.</option>
                            <option value="on hold">Album Prod.</option>
                            <option value="Another Choice">Ready To Ship</option>
                            <option value="Another Choice">Shipped</option>
                            <option value="Another Choice">Reprint</option>
                            <option value="Another Choice">On Hold</option>
                            <option value="Another Choice">Cancelled</option>
                          </select>
                          <div className="div-block-63">
                            <img
                              src="images/chevron-down-12.svg"
                              loading="lazy"
                              alt=""
                              className="img-icon"
                            />
                          </div>
                        </div>
                      </form>
                      <div className="w-form-done">
                        <div>Thank you! Your submission has been received!</div>
                      </div>
                      <div className="w-form-fail">
                        <div>Oops! Something went wrong while submitting the form.</div>
                      </div>
                    </div>
                  </div>
                  <div
                    id="w-node-_50d52765-6c57-ce26-b7f8-0fbbf8674fd8-b74eabf4"
                    className="content"
                  >
                    <a
                      href="/lab-orders/unbundled-line-items"
                      aria-label="Unbundled Line Items Link"
                      className="link-block-11 w-inline-block"
                    >
                      <div className="icon w-embed">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="currentcolor"
                          viewBox="0 0 256 256"
                        >
                          <rect width="256" height="256" fill="none" />
                          <path d="M213.58936,82.2749,157.65723,26.34277c-.08008-.08007-.167-.15039-.25-.22656-.10791-.09912-.21289-.20166-.32618-.29492-.07519-.06152-.15576-.11524-.23291-.17432-.13085-.10009-.26025-.20166-.397-.29394-.062-.04151-.12793-.07617-.19043-.11573-.15869-.10009-.31738-.1997-.4834-.28906-.04492-.02392-.09179-.04248-.13672-.06543-.1875-.09668-.377-.18945-.57275-.271-.03027-.0127-.0625-.022-.09326-.03418-.21045-.08448-.42383-.16358-.64258-.23-.03174-.00977-.06445-.01563-.09619-.02491-.2168-.063-.436-.12109-.66064-.166-.07129-.01416-.145-.02051-.2168-.03272-.18555-.03222-.37012-.06494-.55908-.08349A7.91349,7.91349,0,0,0,152,24H55.99219a16.01833,16.01833,0,0,0-16,16V216a16.01833,16.01833,0,0,0,16,16H200a16.01833,16.01833,0,0,0,16-16V88.15479c.001-.05225.00781-.10254.00781-.15479A7.97147,7.97147,0,0,0,213.58936,82.2749Zm-51.93262,79.38233-28,28c-.023.02313-.04883.04223-.07178.06506-.165.16089-.33447.317-.51269.46326-.09766.08032-.20118.15039-.30176.22534-.1084.08111-.21485.1654-.32764.241-.11621.07794-.2373.1455-.35693.21667-.10449.06244-.20655.12817-.31446.18585-.12011.06439-.24414.119-.36669.17676-.11426.05389-.22657.1109-.34327.15942-.11816.049-.23925.08838-.35937.13135-.126.04541-.251.09387-.37988.133-.11963.03613-.24122.06262-.36231.09308-.13184.03338-.26269.07037-.397.097-.13965.02765-.28028.044-.42041.06415-.11817.01691-.23389.03925-.353.051C128.52686,191.986,128.26367,192,128,192s-.52686-.014-.78955-.03986c-.11914-.01171-.23486-.03405-.353-.051-.14013-.02014-.28076-.0365-.42041-.06415-.13428-.02667-.26513-.06366-.397-.097-.12109-.03046-.24268-.057-.36231-.09308-.1289-.03913-.2539-.08759-.37988-.133-.12012-.043-.24121-.0824-.35937-.13135-.1167-.04852-.229-.10553-.34327-.15942-.12255-.0578-.24658-.11237-.36669-.17676-.10791-.05768-.21-.12341-.31446-.18585-.11963-.07117-.24072-.13873-.35693-.21667-.11279-.07557-.21924-.15986-.32764-.241-.10058-.075-.2041-.145-.30176-.22534-.1748-.14374-.3413-.29718-.50341-.455-.02637-.02563-.05518-.04724-.08106-.0733l-28-28a8,8,0,0,1,11.31348-11.314L120,164.68652V120a8,8,0,0,1,16,0v44.68652l14.34326-14.34326a8,8,0,0,1,11.31348,11.314ZM152,88V43.31348L196.68555,88Z" />
                        </svg>
                      </div>
                    </a>
                  </div>
                </div>
                <div
                  id="w-node-abf4b1f5-4eee-8a36-53fc-f113cb821a0b-b74eabf4"
                  className="w-layout-grid grid-element-order-summary unbundled-list"
                >
                  <div
                    id="w-node-abf4b1f5-4eee-8a36-53fc-f113cb821a0c-b74eabf4"
                    className="content"
                  >
                    <div className="form-block-7 w-form">
                      <form
                        id="email-form-4"
                        name="email-form-4"
                        data-name="Email Form 4"
                        method="get"
                      >
                        <label className="w-checkbox checkbox-field-3">
                          <div className="w-checkbox-input w-checkbox-input--inputType-custom checkbox-4 " />
                          <input
                            type="checkbox"
                            id="checkbox-8"
                            name="checkbox-8"
                            data-name="Checkbox 8"
                            style={{ opacity: 0, position: 'absolute', zIndex: -1 }}
                          />
                          <span className="checkbox-label-2 w-form-label" htmlFor="checkbox-8">
                            Checkbox 8
                          </span>
                        </label>
                      </form>
                      <div className="w-form-done">
                        <div>Thank you! Your submission has been received!</div>
                      </div>
                      <div className="w-form-fail">
                        <div>Oops! Something went wrong while submitting the form.</div>
                      </div>
                    </div>
                  </div>
                  <div
                    id="w-node-abf4b1f5-4eee-8a36-53fc-f113cb821a19-b74eabf4"
                    className="content"
                  >
                    <div className="w-layout-grid grid-90">
                      <div data-tippy-content="mounting" className="dot bigger mounting tippy">
                        <div>MNT</div>
                      </div>
                      <div className="dot bigger paper">
                        <div>PM</div>
                      </div>
                    </div>
                  </div>
                  <div
                    id="w-node-abf4b1f5-4eee-8a36-53fc-f113cb821a21-b74eabf4"
                    className="content"
                  >
                    <div className="div-block-136">
                      <a
                        href="/lab-orders/unbundled-line-items"
                        aria-label="Unbundled Line Items Link"
                        className="w-inline-block w-lightbox"
                      >
                        <img
                          src="images/default-placeholder.jpg"
                          loading="lazy"
                          srcSet="images/default-placeholder-p-500.jpeg 500w, images/default-placeholder-p-800.jpeg 800w, images/default-placeholder-p-1080.jpeg 1080w, images/default-placeholder.jpg 1500w"
                          sizes="(max-width: 479px) 50px, (max-width: 1279px) 80px, 90px"
                          alt=""
                          className="img-order-summary bigger"
                        />
                      </a>
                    </div>
                  </div>
                  <div className="content print-details unbundled-list">
                    <div className="div-block-350">
                      <div className="grey darker">&quot;Sample&quot;</div>
                      <div>Canson Rag 8x8</div>
                      <div className="w-layout-grid grid-23 main align-left">
                        <div className="icon smaller w-embed">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="currentcolor"
                            viewBox="0 0 256 256"
                          >
                            <rect width="256" height="256" fill="none" />
                            <path d="M209.65479,122.3418a8,8,0,0,1-.00733,11.31347l-82.05322,81.94629a56.00006,56.00006,0,0,1-79.1919-79.20019L147.6709,35.751A39.99954,39.99954,0,1,1,204.27832,92.2793l-99.269,100.65136A23.99954,23.99954,0,1,1,71.02979,159.0293L154.291,74.38477a8.0001,8.0001,0,0,1,11.40625,11.2207L82.38965,170.29688a8,8,0,1,0,11.2666,11.36035L192.92578,81.00488a23.99971,23.99971,0,1,0-33.90185-33.97949L59.75488,147.67578a40.00024,40.00024,0,1,0,56.5293,56.6084L198.34082,122.335A7.99885,7.99885,0,0,1,209.65479,122.3418Z" />
                          </svg>
                        </div>
                        <div>name-file.jpg</div>
                      </div>
                      <a href="admin-order-details.html" className="link-block-12 w-inline-block">
                        <div className="w-layout-grid grid-23 main no-padding">
                          <div>MUS-123XYZ</div>
                          <div className="icon smaller w-embed">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              fill="currentcolor"
                              viewBox="0 0 256 256"
                            >
                              <rect width="256" height="256" fill="none" />
                              <line
                                x1="64"
                                y1="192"
                                x2="192"
                                y2="64"
                                fill="none"
                                stroke="currentcolor"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="16"
                              />
                              <polyline
                                points="88 64 192 64 192 168"
                                fill="none"
                                stroke="currentcolor"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="16"
                              />
                            </svg>
                          </div>
                        </div>
                      </a>
                    </div>
                  </div>
                  <div className="content">
                    <div className="text-table-top-container">
                      <div className="text-table _12px semi-bold">Venetian Silver</div>
                      <div className="text-table _12px semi-bold">2&quot; Mat</div>
                      <div className="text-table _12px semi-bold">Standard Acrylic</div>
                    </div>
                  </div>
                  <div className="content">
                    <div className="div-block-357-copy">
                      <div id="text-table" className="text-table smaller red">
                        Completely transform pandemic information via cross functional systems.
                        Proactively harness.
                      </div>
                      <div id="delete" className="w-layout-grid top-buttons-image-element z-index">
                        <div
                          data-w-id="abf4b1f5-4eee-8a36-53fc-f113cb821a41"
                          className="delete-symbol no-margin"
                        >
                          <div className="icon smaller w-embed">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              fill="currentcolor"
                              viewBox="0 0 256 256"
                            >
                              <rect width="256" height="256" fill="none" />
                              <path d="M216,208H115.314l82.33838-82.33887.00489-.00439.00439-.00488L223.999,99.31445A15.99888,15.99888,0,0,0,224,76.68652L179.31348,31.999A16.02162,16.02162,0,0,0,156.68555,32l-120,120.00049a15.95392,15.95392,0,0,0-3.572,5.45654c-.08228.19971-.15162.40283-.21705.60742A15.9896,15.9896,0,0,0,32,163.31348V208a16.01833,16.01833,0,0,0,16,16H216a8,8,0,0,0,0-16ZM168,43.31348,212.68555,88,192,108.68555,147.314,64Z" />
                            </svg>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="w-layout-grid grid-93">
                      <div
                        data-w-id="abf4b1f5-4eee-8a36-53fc-f113cb821a44"
                        className="note-tooltip"
                      >
                        <div className="icon small x2 w-embed">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="currentcolor"
                            viewBox="0 0 256 256"
                          >
                            <rect width="256" height="256" fill="none" />
                            <path d="M208,32H48A16.01081,16.01081,0,0,0,32,48V208a16.01081,16.01081,0,0,0,16,16H156.6875A15.92313,15.92313,0,0,0,168,219.3125L219.3125,168A15.92313,15.92313,0,0,0,224,156.6875V48A16.01081,16.01081,0,0,0,208,32ZM96,88h64a8,8,0,0,1,0,16H96a8,8,0,0,1,0-16Zm32,80H96a8,8,0,0,1,0-16h32a8,8,0,0,1,0,16ZM96,136a8,8,0,0,1,0-16h64a8,8,0,0,1,0,16Zm64,68.6875V159.98438h44.70312Z" />
                          </svg>
                        </div>
                        <div className="div-block-354">
                          <div>C</div>
                        </div>
                        <div style={{ opacity: 0 }} className="client-note">
                          <div className="note-tooltip-wrapper">
                            <div className="div-block-356" />
                            <div className="div-block-357">
                              <div>Client Note:</div>
                              <div id="text-table" className="text-table smaller red">
                                Completely transform pandemic information via cross functional
                                systems. Proactively harness.
                              </div>
                              <div className="line-bottom-note-container " />
                              <div
                                id="delete"
                                className="w-layout-grid top-buttons-image-element z-index"
                              >
                                <div
                                  data-w-id="abf4b1f5-4eee-8a36-53fc-f113cb821a53"
                                  className="delete-symbol"
                                >
                                  <div className="icon smaller w-embed">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      fill="currentcolor"
                                      viewBox="0 0 256 256"
                                    >
                                      <rect width="256" height="256" fill="none" />
                                      <path d="M216,208H115.314l82.33838-82.33887.00489-.00439.00439-.00488L223.999,99.31445A15.99888,15.99888,0,0,0,224,76.68652L179.31348,31.999A16.02162,16.02162,0,0,0,156.68555,32l-120,120.00049a15.95392,15.95392,0,0,0-3.572,5.45654c-.08228.19971-.15162.40283-.21705.60742A15.9896,15.9896,0,0,0,32,163.31348V208a16.01833,16.01833,0,0,0,16,16H216a8,8,0,0,0,0-16ZM168,43.31348,212.68555,88,192,108.68555,147.314,64Z" />
                                    </svg>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        data-w-id="abf4b1f5-4eee-8a36-53fc-f113cb821a55"
                        className="note-tooltip admin"
                      >
                        <div className="icon small x2 w-embed">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="currentcolor"
                            viewBox="0 0 256 256"
                          >
                            <rect width="256" height="256" fill="none" />
                            <path d="M208,32H48A16.01081,16.01081,0,0,0,32,48V208a16.01081,16.01081,0,0,0,16,16H156.6875A15.92313,15.92313,0,0,0,168,219.3125L219.3125,168A15.92313,15.92313,0,0,0,224,156.6875V48A16.01081,16.01081,0,0,0,208,32ZM96,88h64a8,8,0,0,1,0,16H96a8,8,0,0,1,0-16Zm32,80H96a8,8,0,0,1,0-16h32a8,8,0,0,1,0,16ZM96,136a8,8,0,0,1,0-16h64a8,8,0,0,1,0,16Zm64,68.6875V159.98438h44.70312Z" />
                          </svg>
                        </div>
                        <div className="div-block-354 admin">
                          <div>A</div>
                        </div>
                        <div style={{ opacity: 0 }} className="client-note">
                          <div className="note-tooltip-wrapper">
                            <div className="div-block-356" />
                            <div className="div-block-357">
                              <div>Admin Note:</div>
                              <div id="text-table" className="text-table smaller">
                                Completely transform pandemic information via cross functional
                                systems. Proactively harness.
                              </div>
                              <div className="line-bottom-note-container admin " />
                              <div
                                id="delete"
                                className="w-layout-grid top-buttons-image-element z-index"
                              >
                                <div
                                  data-w-id="abf4b1f5-4eee-8a36-53fc-f113cb821a64"
                                  className="delete-symbol"
                                >
                                  <div className="icon smaller w-embed">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      fill="currentcolor"
                                      viewBox="0 0 256 256"
                                    >
                                      <rect width="256" height="256" fill="none" />
                                      <path d="M216,208H115.314l82.33838-82.33887.00489-.00439.00439-.00488L223.999,99.31445A15.99888,15.99888,0,0,0,224,76.68652L179.31348,31.999A16.02162,16.02162,0,0,0,156.68555,32l-120,120.00049a15.95392,15.95392,0,0,0-3.572,5.45654c-.08228.19971-.15162.40283-.21705.60742A15.9896,15.9896,0,0,0,32,163.31348V208a16.01833,16.01833,0,0,0,16,16H216a8,8,0,0,0,0-16ZM168,43.31348,212.68555,88,192,108.68555,147.314,64Z" />
                                    </svg>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        data-w-id="abf4b1f5-4eee-8a36-53fc-f113cb821a66"
                        className="note-tooltip boutique"
                      >
                        <div className="icon small x2 w-embed">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="currentcolor"
                            viewBox="0 0 256 256"
                          >
                            <rect width="256" height="256" fill="none" />
                            <path d="M208,32H48A16.01081,16.01081,0,0,0,32,48V208a16.01081,16.01081,0,0,0,16,16H156.6875A15.92313,15.92313,0,0,0,168,219.3125L219.3125,168A15.92313,15.92313,0,0,0,224,156.6875V48A16.01081,16.01081,0,0,0,208,32ZM96,88h64a8,8,0,0,1,0,16H96a8,8,0,0,1,0-16Zm32,80H96a8,8,0,0,1,0-16h32a8,8,0,0,1,0,16ZM96,136a8,8,0,0,1,0-16h64a8,8,0,0,1,0,16Zm64,68.6875V159.98438h44.70312Z" />
                          </svg>
                        </div>
                        <div className="div-block-354 boutique">
                          <div>B</div>
                        </div>
                        <div style={{ opacity: 0 }} className="client-note">
                          <div className="note-tooltip-wrapper">
                            <div className="div-block-356" />
                            <div className="div-block-357">
                              <div>Boutique Note:</div>
                              <div id="text-table" className="text-table smaller">
                                Completely transform pandemic information via cross functional
                                systems. Proactively harness.
                              </div>
                              <div className="line-bottom-note-container boutique " />
                              <div
                                id="delete"
                                className="w-layout-grid top-buttons-image-element z-index"
                              >
                                <div
                                  data-w-id="abf4b1f5-4eee-8a36-53fc-f113cb821a75"
                                  className="delete-symbol"
                                >
                                  <div className="icon smaller w-embed">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      fill="currentcolor"
                                      viewBox="0 0 256 256"
                                    >
                                      <rect width="256" height="256" fill="none" />
                                      <path d="M216,208H115.314l82.33838-82.33887.00489-.00439.00439-.00488L223.999,99.31445A15.99888,15.99888,0,0,0,224,76.68652L179.31348,31.999A16.02162,16.02162,0,0,0,156.68555,32l-120,120.00049a15.95392,15.95392,0,0,0-3.572,5.45654c-.08228.19971-.15162.40283-.21705.60742A15.9896,15.9896,0,0,0,32,163.31348V208a16.01833,16.01833,0,0,0,16,16H216a8,8,0,0,0,0-16ZM168,43.31348,212.68555,88,192,108.68555,147.314,64Z" />
                                    </svg>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    id="w-node-abf4b1f5-4eee-8a36-53fc-f113cb821a77-b74eabf4"
                    className="content"
                  >
                    <div className="text-table red">04</div>
                  </div>
                  <div
                    id="w-node-abf4b1f5-4eee-8a36-53fc-f113cb821a7a-b74eabf4"
                    className="content"
                  >
                    <div className="text-table price">$ 30.00</div>
                  </div>
                  <div
                    id="w-node-abf4b1f5-4eee-8a36-53fc-f113cb821a7d-b74eabf4"
                    className="content"
                  >
                    <div className="form-block-input w-form">
                      <form
                        id="email-form"
                        name="email-form"
                        data-name="Email Form"
                        method="get"
                        className="form-input select-field"
                      >
                        <div className="select-field-wrapper">
                          <select
                            id="save"
                            name="field-3"
                            data-name="Field 3"
                            className="form-select-field w-select"
                          >
                            <option value="open">Printing</option>
                            <option value="paid">Matting</option>
                            <option value="shipped">Mounting</option>
                            <option value="in production">Framing</option>
                            <option value="Cancelled">Canvas Prod.</option>
                            <option value="on hold">Album Prod.</option>
                            <option value="Another Choice">Ready To Ship</option>
                            <option value="Another Choice">Shipped</option>
                            <option value="Another Choice">Reprint</option>
                            <option value="Another Choice">On Hold</option>
                            <option value="Another Choice">Cancelled</option>
                          </select>
                          <div className="div-block-63">
                            <img
                              src="images/chevron-down-12.svg"
                              loading="lazy"
                              alt=""
                              className="img-icon"
                            />
                          </div>
                        </div>
                      </form>
                      <div className="w-form-done">
                        <div>Thank you! Your submission has been received!</div>
                      </div>
                      <div className="w-form-fail">
                        <div>Oops! Something went wrong while submitting the form.</div>
                      </div>
                    </div>
                  </div>
                  <div
                    id="w-node-abf4b1f5-4eee-8a36-53fc-f113cb821a8b-b74eabf4"
                    className="content"
                  >
                    <a
                      href="/lab-orders/unbundled-line-items"
                      aria-label="Unbundled Line Items Link"
                      className="link-block-11 w-inline-block"
                    >
                      <div className="icon w-embed">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="currentcolor"
                          viewBox="0 0 256 256"
                        >
                          <rect width="256" height="256" fill="none" />
                          <path d="M213.58936,82.2749,157.65723,26.34277c-.08008-.08007-.167-.15039-.25-.22656-.10791-.09912-.21289-.20166-.32618-.29492-.07519-.06152-.15576-.11524-.23291-.17432-.13085-.10009-.26025-.20166-.397-.29394-.062-.04151-.12793-.07617-.19043-.11573-.15869-.10009-.31738-.1997-.4834-.28906-.04492-.02392-.09179-.04248-.13672-.06543-.1875-.09668-.377-.18945-.57275-.271-.03027-.0127-.0625-.022-.09326-.03418-.21045-.08448-.42383-.16358-.64258-.23-.03174-.00977-.06445-.01563-.09619-.02491-.2168-.063-.436-.12109-.66064-.166-.07129-.01416-.145-.02051-.2168-.03272-.18555-.03222-.37012-.06494-.55908-.08349A7.91349,7.91349,0,0,0,152,24H55.99219a16.01833,16.01833,0,0,0-16,16V216a16.01833,16.01833,0,0,0,16,16H200a16.01833,16.01833,0,0,0,16-16V88.15479c.001-.05225.00781-.10254.00781-.15479A7.97147,7.97147,0,0,0,213.58936,82.2749Zm-51.93262,79.38233-28,28c-.023.02313-.04883.04223-.07178.06506-.165.16089-.33447.317-.51269.46326-.09766.08032-.20118.15039-.30176.22534-.1084.08111-.21485.1654-.32764.241-.11621.07794-.2373.1455-.35693.21667-.10449.06244-.20655.12817-.31446.18585-.12011.06439-.24414.119-.36669.17676-.11426.05389-.22657.1109-.34327.15942-.11816.049-.23925.08838-.35937.13135-.126.04541-.251.09387-.37988.133-.11963.03613-.24122.06262-.36231.09308-.13184.03338-.26269.07037-.397.097-.13965.02765-.28028.044-.42041.06415-.11817.01691-.23389.03925-.353.051C128.52686,191.986,128.26367,192,128,192s-.52686-.014-.78955-.03986c-.11914-.01171-.23486-.03405-.353-.051-.14013-.02014-.28076-.0365-.42041-.06415-.13428-.02667-.26513-.06366-.397-.097-.12109-.03046-.24268-.057-.36231-.09308-.1289-.03913-.2539-.08759-.37988-.133-.12012-.043-.24121-.0824-.35937-.13135-.1167-.04852-.229-.10553-.34327-.15942-.12255-.0578-.24658-.11237-.36669-.17676-.10791-.05768-.21-.12341-.31446-.18585-.11963-.07117-.24072-.13873-.35693-.21667-.11279-.07557-.21924-.15986-.32764-.241-.10058-.075-.2041-.145-.30176-.22534-.1748-.14374-.3413-.29718-.50341-.455-.02637-.02563-.05518-.04724-.08106-.0733l-28-28a8,8,0,0,1,11.31348-11.314L120,164.68652V120a8,8,0,0,1,16,0v44.68652l14.34326-14.34326a8,8,0,0,1,11.31348,11.314ZM152,88V43.31348L196.68555,88Z" />
                        </svg>
                      </div>
                    </a>
                  </div>
                </div>
                <div
                  id="w-node-_3f065201-2cac-761c-3070-1934613cbeaf-b74eabf4"
                  className="w-layout-grid grid-element-order-summary unbundled-list"
                >
                  <div
                    id="w-node-_3f065201-2cac-761c-3070-1934613cbeb0-b74eabf4"
                    className="content"
                  >
                    <div className="form-block-7 w-form">
                      <form
                        id="email-form-4"
                        name="email-form-4"
                        data-name="Email Form 4"
                        method="get"
                      >
                        <label className="w-checkbox checkbox-field-3">
                          <div className="w-checkbox-input w-checkbox-input--inputType-custom checkbox-4 " />
                          <input
                            type="checkbox"
                            id="checkbox-8"
                            name="checkbox-8"
                            data-name="Checkbox 8"
                            style={{ opacity: 0, position: 'absolute', zIndex: -1 }}
                          />
                          <span className="checkbox-label-2 w-form-label" htmlFor="checkbox-8">
                            Checkbox 8
                          </span>
                        </label>
                      </form>
                      <div className="w-form-done">
                        <div>Thank you! Your submission has been received!</div>
                      </div>
                      <div className="w-form-fail">
                        <div>Oops! Something went wrong while submitting the form.</div>
                      </div>
                    </div>
                  </div>
                  <div
                    id="w-node-_3f065201-2cac-761c-3070-1934613cbebd-b74eabf4"
                    className="content"
                  >
                    <div className="w-layout-grid grid-90">
                      <div data-tippy-content="mounting" className="dot bigger mounting tippy">
                        <div>MNT</div>
                      </div>
                      <div className="dot bigger paper">
                        <div>PM</div>
                      </div>
                    </div>
                  </div>
                  <div
                    id="w-node-_3f065201-2cac-761c-3070-1934613cbec5-b74eabf4"
                    className="content"
                  >
                    <div className="div-block-136">
                      <a
                        href="/lab-orders/unbundled-line-items"
                        aria-label="Unbundled Line Items Link"
                        className="w-inline-block w-lightbox"
                      >
                        <img
                          src="images/default-placeholder.jpg"
                          loading="lazy"
                          srcSet="images/default-placeholder-p-500.jpeg 500w, images/default-placeholder-p-800.jpeg 800w, images/default-placeholder-p-1080.jpeg 1080w, images/default-placeholder.jpg 1500w"
                          sizes="(max-width: 479px) 50px, (max-width: 1279px) 80px, 90px"
                          alt=""
                          className="img-order-summary bigger"
                        />
                      </a>
                    </div>
                  </div>
                  <div className="content print-details unbundled-list">
                    <div className="div-block-350">
                      <div className="grey darker">&quot;Sample&quot;</div>
                      <div>Canson Rag 8x8</div>
                      <div className="w-layout-grid grid-23 main align-left">
                        <div className="icon smaller w-embed">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="currentcolor"
                            viewBox="0 0 256 256"
                          >
                            <rect width="256" height="256" fill="none" />
                            <path d="M209.65479,122.3418a8,8,0,0,1-.00733,11.31347l-82.05322,81.94629a56.00006,56.00006,0,0,1-79.1919-79.20019L147.6709,35.751A39.99954,39.99954,0,1,1,204.27832,92.2793l-99.269,100.65136A23.99954,23.99954,0,1,1,71.02979,159.0293L154.291,74.38477a8.0001,8.0001,0,0,1,11.40625,11.2207L82.38965,170.29688a8,8,0,1,0,11.2666,11.36035L192.92578,81.00488a23.99971,23.99971,0,1,0-33.90185-33.97949L59.75488,147.67578a40.00024,40.00024,0,1,0,56.5293,56.6084L198.34082,122.335A7.99885,7.99885,0,0,1,209.65479,122.3418Z" />
                          </svg>
                        </div>
                        <div>name-file.jpg</div>
                      </div>
                      <a href="admin-order-details.html" className="link-block-12 w-inline-block">
                        <div className="w-layout-grid grid-23 main no-padding">
                          <div>MUS-123XYZ</div>
                          <div className="icon smaller w-embed">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              fill="currentcolor"
                              viewBox="0 0 256 256"
                            >
                              <rect width="256" height="256" fill="none" />
                              <line
                                x1="64"
                                y1="192"
                                x2="192"
                                y2="64"
                                fill="none"
                                stroke="currentcolor"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="16"
                              />
                              <polyline
                                points="88 64 192 64 192 168"
                                fill="none"
                                stroke="currentcolor"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="16"
                              />
                            </svg>
                          </div>
                        </div>
                      </a>
                    </div>
                  </div>
                  <div className="content">
                    <div className="text-table-top-container">
                      <div className="text-table _12px semi-bold">Venetian Silver</div>
                      <div className="text-table _12px semi-bold">2&quot; Mat</div>
                      <div className="text-table _12px semi-bold">Standard Acrylic</div>
                    </div>
                  </div>
                  <div className="content">
                    <div className="div-block-357-copy">
                      <div id="text-table" className="text-table smaller red">
                        Completely transform pandemic information via cross functional systems.
                        Proactively harness.
                      </div>
                      <div id="delete" className="w-layout-grid top-buttons-image-element z-index">
                        <div
                          data-w-id="3f065201-2cac-761c-3070-1934613cbee5"
                          className="delete-symbol no-margin"
                        >
                          <div className="icon smaller w-embed">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              fill="currentcolor"
                              viewBox="0 0 256 256"
                            >
                              <rect width="256" height="256" fill="none" />
                              <path d="M216,208H115.314l82.33838-82.33887.00489-.00439.00439-.00488L223.999,99.31445A15.99888,15.99888,0,0,0,224,76.68652L179.31348,31.999A16.02162,16.02162,0,0,0,156.68555,32l-120,120.00049a15.95392,15.95392,0,0,0-3.572,5.45654c-.08228.19971-.15162.40283-.21705.60742A15.9896,15.9896,0,0,0,32,163.31348V208a16.01833,16.01833,0,0,0,16,16H216a8,8,0,0,0,0-16ZM168,43.31348,212.68555,88,192,108.68555,147.314,64Z" />
                            </svg>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="w-layout-grid grid-93">
                      <div
                        data-w-id="3f065201-2cac-761c-3070-1934613cbee8"
                        className="note-tooltip"
                      >
                        <div className="icon small x2 w-embed">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="currentcolor"
                            viewBox="0 0 256 256"
                          >
                            <rect width="256" height="256" fill="none" />
                            <path d="M208,32H48A16.01081,16.01081,0,0,0,32,48V208a16.01081,16.01081,0,0,0,16,16H156.6875A15.92313,15.92313,0,0,0,168,219.3125L219.3125,168A15.92313,15.92313,0,0,0,224,156.6875V48A16.01081,16.01081,0,0,0,208,32ZM96,88h64a8,8,0,0,1,0,16H96a8,8,0,0,1,0-16Zm32,80H96a8,8,0,0,1,0-16h32a8,8,0,0,1,0,16ZM96,136a8,8,0,0,1,0-16h64a8,8,0,0,1,0,16Zm64,68.6875V159.98438h44.70312Z" />
                          </svg>
                        </div>
                        <div className="div-block-354">
                          <div>C</div>
                        </div>
                        <div style={{ opacity: 0 }} className="client-note">
                          <div className="note-tooltip-wrapper">
                            <div className="div-block-356" />
                            <div className="div-block-357">
                              <div>Client Note:</div>
                              <div id="text-table" className="text-table smaller red">
                                Completely transform pandemic information via cross functional
                                systems. Proactively harness.
                              </div>
                              <div className="line-bottom-note-container " />
                              <div
                                id="delete"
                                className="w-layout-grid top-buttons-image-element z-index"
                              >
                                <div
                                  data-w-id="3f065201-2cac-761c-3070-1934613cbef7"
                                  className="delete-symbol"
                                >
                                  <div className="icon smaller w-embed">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      fill="currentcolor"
                                      viewBox="0 0 256 256"
                                    >
                                      <rect width="256" height="256" fill="none" />
                                      <path d="M216,208H115.314l82.33838-82.33887.00489-.00439.00439-.00488L223.999,99.31445A15.99888,15.99888,0,0,0,224,76.68652L179.31348,31.999A16.02162,16.02162,0,0,0,156.68555,32l-120,120.00049a15.95392,15.95392,0,0,0-3.572,5.45654c-.08228.19971-.15162.40283-.21705.60742A15.9896,15.9896,0,0,0,32,163.31348V208a16.01833,16.01833,0,0,0,16,16H216a8,8,0,0,0,0-16ZM168,43.31348,212.68555,88,192,108.68555,147.314,64Z" />
                                    </svg>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        data-w-id="3f065201-2cac-761c-3070-1934613cbef9"
                        className="note-tooltip admin"
                      >
                        <div className="icon small x2 w-embed">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="currentcolor"
                            viewBox="0 0 256 256"
                          >
                            <rect width="256" height="256" fill="none" />
                            <path d="M208,32H48A16.01081,16.01081,0,0,0,32,48V208a16.01081,16.01081,0,0,0,16,16H156.6875A15.92313,15.92313,0,0,0,168,219.3125L219.3125,168A15.92313,15.92313,0,0,0,224,156.6875V48A16.01081,16.01081,0,0,0,208,32ZM96,88h64a8,8,0,0,1,0,16H96a8,8,0,0,1,0-16Zm32,80H96a8,8,0,0,1,0-16h32a8,8,0,0,1,0,16ZM96,136a8,8,0,0,1,0-16h64a8,8,0,0,1,0,16Zm64,68.6875V159.98438h44.70312Z" />
                          </svg>
                        </div>
                        <div className="div-block-354 admin">
                          <div>A</div>
                        </div>
                        <div style={{ opacity: 0 }} className="client-note">
                          <div className="note-tooltip-wrapper">
                            <div className="div-block-356" />
                            <div className="div-block-357">
                              <div>Admin Note:</div>
                              <div id="text-table" className="text-table smaller">
                                Completely transform pandemic information via cross functional
                                systems. Proactively harness.
                              </div>
                              <div className="line-bottom-note-container admin " />
                              <div
                                id="delete"
                                className="w-layout-grid top-buttons-image-element z-index"
                              >
                                <div
                                  data-w-id="3f065201-2cac-761c-3070-1934613cbf08"
                                  className="delete-symbol"
                                >
                                  <div className="icon smaller w-embed">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      fill="currentcolor"
                                      viewBox="0 0 256 256"
                                    >
                                      <rect width="256" height="256" fill="none" />
                                      <path d="M216,208H115.314l82.33838-82.33887.00489-.00439.00439-.00488L223.999,99.31445A15.99888,15.99888,0,0,0,224,76.68652L179.31348,31.999A16.02162,16.02162,0,0,0,156.68555,32l-120,120.00049a15.95392,15.95392,0,0,0-3.572,5.45654c-.08228.19971-.15162.40283-.21705.60742A15.9896,15.9896,0,0,0,32,163.31348V208a16.01833,16.01833,0,0,0,16,16H216a8,8,0,0,0,0-16ZM168,43.31348,212.68555,88,192,108.68555,147.314,64Z" />
                                    </svg>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        data-w-id="3f065201-2cac-761c-3070-1934613cbf0a"
                        className="note-tooltip boutique"
                      >
                        <div className="icon small x2 w-embed">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="currentcolor"
                            viewBox="0 0 256 256"
                          >
                            <rect width="256" height="256" fill="none" />
                            <path d="M208,32H48A16.01081,16.01081,0,0,0,32,48V208a16.01081,16.01081,0,0,0,16,16H156.6875A15.92313,15.92313,0,0,0,168,219.3125L219.3125,168A15.92313,15.92313,0,0,0,224,156.6875V48A16.01081,16.01081,0,0,0,208,32ZM96,88h64a8,8,0,0,1,0,16H96a8,8,0,0,1,0-16Zm32,80H96a8,8,0,0,1,0-16h32a8,8,0,0,1,0,16ZM96,136a8,8,0,0,1,0-16h64a8,8,0,0,1,0,16Zm64,68.6875V159.98438h44.70312Z" />
                          </svg>
                        </div>
                        <div className="div-block-354 boutique">
                          <div>B</div>
                        </div>
                        <div style={{ opacity: 0 }} className="client-note">
                          <div className="note-tooltip-wrapper">
                            <div className="div-block-356" />
                            <div className="div-block-357">
                              <div>Boutique Note:</div>
                              <div id="text-table" className="text-table smaller">
                                Completely transform pandemic information via cross functional
                                systems. Proactively harness.
                              </div>
                              <div className="line-bottom-note-container boutique " />
                              <div
                                id="delete"
                                className="w-layout-grid top-buttons-image-element z-index"
                              >
                                <div
                                  data-w-id="3f065201-2cac-761c-3070-1934613cbf19"
                                  className="delete-symbol"
                                >
                                  <div className="icon smaller w-embed">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      fill="currentcolor"
                                      viewBox="0 0 256 256"
                                    >
                                      <rect width="256" height="256" fill="none" />
                                      <path d="M216,208H115.314l82.33838-82.33887.00489-.00439.00439-.00488L223.999,99.31445A15.99888,15.99888,0,0,0,224,76.68652L179.31348,31.999A16.02162,16.02162,0,0,0,156.68555,32l-120,120.00049a15.95392,15.95392,0,0,0-3.572,5.45654c-.08228.19971-.15162.40283-.21705.60742A15.9896,15.9896,0,0,0,32,163.31348V208a16.01833,16.01833,0,0,0,16,16H216a8,8,0,0,0,0-16ZM168,43.31348,212.68555,88,192,108.68555,147.314,64Z" />
                                    </svg>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    id="w-node-_3f065201-2cac-761c-3070-1934613cbf1b-b74eabf4"
                    className="content"
                  >
                    <div className="text-table red">04</div>
                  </div>
                  <div
                    id="w-node-_3f065201-2cac-761c-3070-1934613cbf1e-b74eabf4"
                    className="content"
                  >
                    <div className="text-table price">$ 30.00</div>
                  </div>
                  <div
                    id="w-node-_3f065201-2cac-761c-3070-1934613cbf21-b74eabf4"
                    className="content"
                  >
                    <div className="form-block-input w-form">
                      <form
                        id="email-form"
                        name="email-form"
                        data-name="Email Form"
                        method="get"
                        className="form-input select-field"
                      >
                        <div className="select-field-wrapper">
                          <select
                            id="save"
                            name="field-3"
                            data-name="Field 3"
                            className="form-select-field w-select"
                          >
                            <option value="open">Printing</option>
                            <option value="paid">Matting</option>
                            <option value="shipped">Mounting</option>
                            <option value="in production">Framing</option>
                            <option value="Cancelled">Canvas Prod.</option>
                            <option value="on hold">Album Prod.</option>
                            <option value="Another Choice">Ready To Ship</option>
                            <option value="Another Choice">Shipped</option>
                            <option value="Another Choice">Reprint</option>
                            <option value="Another Choice">On Hold</option>
                            <option value="Another Choice">Cancelled</option>
                          </select>
                          <div className="div-block-63">
                            <img
                              src="images/chevron-down-12.svg"
                              loading="lazy"
                              alt=""
                              className="img-icon"
                            />
                          </div>
                        </div>
                      </form>
                      <div className="w-form-done">
                        <div>Thank you! Your submission has been received!</div>
                      </div>
                      <div className="w-form-fail">
                        <div>Oops! Something went wrong while submitting the form.</div>
                      </div>
                    </div>
                  </div>
                  <div
                    id="w-node-_3f065201-2cac-761c-3070-1934613cbf2f-b74eabf4"
                    className="content"
                  >
                    <a
                      href="/lab-orders/unbundled-line-items"
                      aria-label="Unbundled Line Items Link"
                      className="link-block-11 w-inline-block"
                    >
                      <div className="icon w-embed">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="currentcolor"
                          viewBox="0 0 256 256"
                        >
                          <rect width="256" height="256" fill="none" />
                          <path d="M213.58936,82.2749,157.65723,26.34277c-.08008-.08007-.167-.15039-.25-.22656-.10791-.09912-.21289-.20166-.32618-.29492-.07519-.06152-.15576-.11524-.23291-.17432-.13085-.10009-.26025-.20166-.397-.29394-.062-.04151-.12793-.07617-.19043-.11573-.15869-.10009-.31738-.1997-.4834-.28906-.04492-.02392-.09179-.04248-.13672-.06543-.1875-.09668-.377-.18945-.57275-.271-.03027-.0127-.0625-.022-.09326-.03418-.21045-.08448-.42383-.16358-.64258-.23-.03174-.00977-.06445-.01563-.09619-.02491-.2168-.063-.436-.12109-.66064-.166-.07129-.01416-.145-.02051-.2168-.03272-.18555-.03222-.37012-.06494-.55908-.08349A7.91349,7.91349,0,0,0,152,24H55.99219a16.01833,16.01833,0,0,0-16,16V216a16.01833,16.01833,0,0,0,16,16H200a16.01833,16.01833,0,0,0,16-16V88.15479c.001-.05225.00781-.10254.00781-.15479A7.97147,7.97147,0,0,0,213.58936,82.2749Zm-51.93262,79.38233-28,28c-.023.02313-.04883.04223-.07178.06506-.165.16089-.33447.317-.51269.46326-.09766.08032-.20118.15039-.30176.22534-.1084.08111-.21485.1654-.32764.241-.11621.07794-.2373.1455-.35693.21667-.10449.06244-.20655.12817-.31446.18585-.12011.06439-.24414.119-.36669.17676-.11426.05389-.22657.1109-.34327.15942-.11816.049-.23925.08838-.35937.13135-.126.04541-.251.09387-.37988.133-.11963.03613-.24122.06262-.36231.09308-.13184.03338-.26269.07037-.397.097-.13965.02765-.28028.044-.42041.06415-.11817.01691-.23389.03925-.353.051C128.52686,191.986,128.26367,192,128,192s-.52686-.014-.78955-.03986c-.11914-.01171-.23486-.03405-.353-.051-.14013-.02014-.28076-.0365-.42041-.06415-.13428-.02667-.26513-.06366-.397-.097-.12109-.03046-.24268-.057-.36231-.09308-.1289-.03913-.2539-.08759-.37988-.133-.12012-.043-.24121-.0824-.35937-.13135-.1167-.04852-.229-.10553-.34327-.15942-.12255-.0578-.24658-.11237-.36669-.17676-.10791-.05768-.21-.12341-.31446-.18585-.11963-.07117-.24072-.13873-.35693-.21667-.11279-.07557-.21924-.15986-.32764-.241-.10058-.075-.2041-.145-.30176-.22534-.1748-.14374-.3413-.29718-.50341-.455-.02637-.02563-.05518-.04724-.08106-.0733l-28-28a8,8,0,0,1,11.31348-11.314L120,164.68652V120a8,8,0,0,1,16,0v44.68652l14.34326-14.34326a8,8,0,0,1,11.31348,11.314ZM152,88V43.31348L196.68555,88Z" />
                        </svg>
                      </div>
                    </a>
                  </div>
                </div>
                <div
                  id="w-node-_073e8027-4c92-1381-c06b-31f08469ee93-b74eabf4"
                  className="w-layout-grid grid-element-order-summary unbundled-list"
                >
                  <div
                    id="w-node-_073e8027-4c92-1381-c06b-31f08469ee94-b74eabf4"
                    className="content"
                  >
                    <div className="form-block-7 w-form">
                      <form
                        id="email-form-4"
                        name="email-form-4"
                        data-name="Email Form 4"
                        method="get"
                      >
                        <label className="w-checkbox checkbox-field-3">
                          <div className="w-checkbox-input w-checkbox-input--inputType-custom checkbox-4 " />
                          <input
                            type="checkbox"
                            id="checkbox-8"
                            name="checkbox-8"
                            data-name="Checkbox 8"
                            style={{ opacity: 0, position: 'absolute', zIndex: -1 }}
                          />
                          <span className="checkbox-label-2 w-form-label" htmlFor="checkbox-8">
                            Checkbox 8
                          </span>
                        </label>
                      </form>
                      <div className="w-form-done">
                        <div>Thank you! Your submission has been received!</div>
                      </div>
                      <div className="w-form-fail">
                        <div>Oops! Something went wrong while submitting the form.</div>
                      </div>
                    </div>
                  </div>
                  <div
                    id="w-node-_073e8027-4c92-1381-c06b-31f08469eea1-b74eabf4"
                    className="content"
                  >
                    <div className="w-layout-grid grid-90">
                      <div data-tippy-content="mounting" className="dot bigger mounting tippy">
                        <div>MNT</div>
                      </div>
                      <div className="dot bigger paper">
                        <div>PM</div>
                      </div>
                    </div>
                  </div>
                  <div
                    id="w-node-_073e8027-4c92-1381-c06b-31f08469eea9-b74eabf4"
                    className="content"
                  >
                    <div className="div-block-136">
                      <a
                        href="/lab-orders/unbundled-line-items"
                        aria-label="Unbundled Line Items Link"
                        className="w-inline-block w-lightbox"
                      >
                        <img
                          src="images/default-placeholder.jpg"
                          loading="lazy"
                          srcSet="images/default-placeholder-p-500.jpeg 500w, images/default-placeholder-p-800.jpeg 800w, images/default-placeholder-p-1080.jpeg 1080w, images/default-placeholder.jpg 1500w"
                          sizes="(max-width: 479px) 50px, (max-width: 1279px) 80px, 90px"
                          alt=""
                          className="img-order-summary bigger"
                        />
                      </a>
                    </div>
                  </div>
                  <div className="content print-details unbundled-list">
                    <div className="div-block-350">
                      <div className="grey darker">&quot;Sample&quot;</div>
                      <div>Canson Rag 8x8</div>
                      <div className="w-layout-grid grid-23 main align-left">
                        <div className="icon smaller w-embed">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="currentcolor"
                            viewBox="0 0 256 256"
                          >
                            <rect width="256" height="256" fill="none" />
                            <path d="M209.65479,122.3418a8,8,0,0,1-.00733,11.31347l-82.05322,81.94629a56.00006,56.00006,0,0,1-79.1919-79.20019L147.6709,35.751A39.99954,39.99954,0,1,1,204.27832,92.2793l-99.269,100.65136A23.99954,23.99954,0,1,1,71.02979,159.0293L154.291,74.38477a8.0001,8.0001,0,0,1,11.40625,11.2207L82.38965,170.29688a8,8,0,1,0,11.2666,11.36035L192.92578,81.00488a23.99971,23.99971,0,1,0-33.90185-33.97949L59.75488,147.67578a40.00024,40.00024,0,1,0,56.5293,56.6084L198.34082,122.335A7.99885,7.99885,0,0,1,209.65479,122.3418Z" />
                          </svg>
                        </div>
                        <div>name-file.jpg</div>
                      </div>
                      <a href="admin-order-details.html" className="link-block-12 w-inline-block">
                        <div className="w-layout-grid grid-23 main no-padding">
                          <div>MUS-123XYZ</div>
                          <div className="icon smaller w-embed">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              fill="currentcolor"
                              viewBox="0 0 256 256"
                            >
                              <rect width="256" height="256" fill="none" />
                              <line
                                x1="64"
                                y1="192"
                                x2="192"
                                y2="64"
                                fill="none"
                                stroke="currentcolor"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="16"
                              />
                              <polyline
                                points="88 64 192 64 192 168"
                                fill="none"
                                stroke="currentcolor"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="16"
                              />
                            </svg>
                          </div>
                        </div>
                      </a>
                    </div>
                  </div>
                  <div className="content">
                    <div className="text-table-top-container">
                      <div className="text-table _12px semi-bold">Venetian Silver</div>
                      <div className="text-table _12px semi-bold">2&quot; Mat</div>
                      <div className="text-table _12px semi-bold">Standard Acrylic</div>
                    </div>
                  </div>
                  <div className="content">
                    <div className="div-block-357-copy">
                      <div id="text-table" className="text-table smaller red">
                        Completely transform pandemic information via cross functional systems.
                        Proactively harness.
                      </div>
                      <div id="delete" className="w-layout-grid top-buttons-image-element z-index">
                        <div
                          data-w-id="073e8027-4c92-1381-c06b-31f08469eec9"
                          className="delete-symbol no-margin"
                        >
                          <div className="icon smaller w-embed">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              fill="currentcolor"
                              viewBox="0 0 256 256"
                            >
                              <rect width="256" height="256" fill="none" />
                              <path d="M216,208H115.314l82.33838-82.33887.00489-.00439.00439-.00488L223.999,99.31445A15.99888,15.99888,0,0,0,224,76.68652L179.31348,31.999A16.02162,16.02162,0,0,0,156.68555,32l-120,120.00049a15.95392,15.95392,0,0,0-3.572,5.45654c-.08228.19971-.15162.40283-.21705.60742A15.9896,15.9896,0,0,0,32,163.31348V208a16.01833,16.01833,0,0,0,16,16H216a8,8,0,0,0,0-16ZM168,43.31348,212.68555,88,192,108.68555,147.314,64Z" />
                            </svg>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="w-layout-grid grid-93">
                      <div
                        data-w-id="073e8027-4c92-1381-c06b-31f08469eecc"
                        className="note-tooltip"
                      >
                        <div className="icon small x2 w-embed">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="currentcolor"
                            viewBox="0 0 256 256"
                          >
                            <rect width="256" height="256" fill="none" />
                            <path d="M208,32H48A16.01081,16.01081,0,0,0,32,48V208a16.01081,16.01081,0,0,0,16,16H156.6875A15.92313,15.92313,0,0,0,168,219.3125L219.3125,168A15.92313,15.92313,0,0,0,224,156.6875V48A16.01081,16.01081,0,0,0,208,32ZM96,88h64a8,8,0,0,1,0,16H96a8,8,0,0,1,0-16Zm32,80H96a8,8,0,0,1,0-16h32a8,8,0,0,1,0,16ZM96,136a8,8,0,0,1,0-16h64a8,8,0,0,1,0,16Zm64,68.6875V159.98438h44.70312Z" />
                          </svg>
                        </div>
                        <div className="div-block-354">
                          <div>C</div>
                        </div>
                        <div style={{ opacity: 0 }} className="client-note">
                          <div className="note-tooltip-wrapper">
                            <div className="div-block-356" />
                            <div className="div-block-357">
                              <div>Client Note:</div>
                              <div id="text-table" className="text-table smaller red">
                                Completely transform pandemic information via cross functional
                                systems. Proactively harness.
                              </div>
                              <div className="line-bottom-note-container " />
                              <div
                                id="delete"
                                className="w-layout-grid top-buttons-image-element z-index"
                              >
                                <div
                                  data-w-id="073e8027-4c92-1381-c06b-31f08469eedb"
                                  className="delete-symbol"
                                >
                                  <div className="icon smaller w-embed">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      fill="currentcolor"
                                      viewBox="0 0 256 256"
                                    >
                                      <rect width="256" height="256" fill="none" />
                                      <path d="M216,208H115.314l82.33838-82.33887.00489-.00439.00439-.00488L223.999,99.31445A15.99888,15.99888,0,0,0,224,76.68652L179.31348,31.999A16.02162,16.02162,0,0,0,156.68555,32l-120,120.00049a15.95392,15.95392,0,0,0-3.572,5.45654c-.08228.19971-.15162.40283-.21705.60742A15.9896,15.9896,0,0,0,32,163.31348V208a16.01833,16.01833,0,0,0,16,16H216a8,8,0,0,0,0-16ZM168,43.31348,212.68555,88,192,108.68555,147.314,64Z" />
                                    </svg>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        data-w-id="073e8027-4c92-1381-c06b-31f08469eedd"
                        className="note-tooltip admin"
                      >
                        <div className="icon small x2 w-embed">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="currentcolor"
                            viewBox="0 0 256 256"
                          >
                            <rect width="256" height="256" fill="none" />
                            <path d="M208,32H48A16.01081,16.01081,0,0,0,32,48V208a16.01081,16.01081,0,0,0,16,16H156.6875A15.92313,15.92313,0,0,0,168,219.3125L219.3125,168A15.92313,15.92313,0,0,0,224,156.6875V48A16.01081,16.01081,0,0,0,208,32ZM96,88h64a8,8,0,0,1,0,16H96a8,8,0,0,1,0-16Zm32,80H96a8,8,0,0,1,0-16h32a8,8,0,0,1,0,16ZM96,136a8,8,0,0,1,0-16h64a8,8,0,0,1,0,16Zm64,68.6875V159.98438h44.70312Z" />
                          </svg>
                        </div>
                        <div className="div-block-354 admin">
                          <div>A</div>
                        </div>
                        <div style={{ opacity: 0 }} className="client-note">
                          <div className="note-tooltip-wrapper">
                            <div className="div-block-356" />
                            <div className="div-block-357">
                              <div>Admin Note:</div>
                              <div id="text-table" className="text-table smaller">
                                Completely transform pandemic information via cross functional
                                systems. Proactively harness.
                              </div>
                              <div className="line-bottom-note-container admin " />
                              <div
                                id="delete"
                                className="w-layout-grid top-buttons-image-element z-index"
                              >
                                <div
                                  data-w-id="073e8027-4c92-1381-c06b-31f08469eeec"
                                  className="delete-symbol"
                                >
                                  <div className="icon smaller w-embed">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      fill="currentcolor"
                                      viewBox="0 0 256 256"
                                    >
                                      <rect width="256" height="256" fill="none" />
                                      <path d="M216,208H115.314l82.33838-82.33887.00489-.00439.00439-.00488L223.999,99.31445A15.99888,15.99888,0,0,0,224,76.68652L179.31348,31.999A16.02162,16.02162,0,0,0,156.68555,32l-120,120.00049a15.95392,15.95392,0,0,0-3.572,5.45654c-.08228.19971-.15162.40283-.21705.60742A15.9896,15.9896,0,0,0,32,163.31348V208a16.01833,16.01833,0,0,0,16,16H216a8,8,0,0,0,0-16ZM168,43.31348,212.68555,88,192,108.68555,147.314,64Z" />
                                    </svg>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        data-w-id="073e8027-4c92-1381-c06b-31f08469eeee"
                        className="note-tooltip boutique"
                      >
                        <div className="icon small x2 w-embed">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="currentcolor"
                            viewBox="0 0 256 256"
                          >
                            <rect width="256" height="256" fill="none" />
                            <path d="M208,32H48A16.01081,16.01081,0,0,0,32,48V208a16.01081,16.01081,0,0,0,16,16H156.6875A15.92313,15.92313,0,0,0,168,219.3125L219.3125,168A15.92313,15.92313,0,0,0,224,156.6875V48A16.01081,16.01081,0,0,0,208,32ZM96,88h64a8,8,0,0,1,0,16H96a8,8,0,0,1,0-16Zm32,80H96a8,8,0,0,1,0-16h32a8,8,0,0,1,0,16ZM96,136a8,8,0,0,1,0-16h64a8,8,0,0,1,0,16Zm64,68.6875V159.98438h44.70312Z" />
                          </svg>
                        </div>
                        <div className="div-block-354 boutique">
                          <div>B</div>
                        </div>
                        <div style={{ opacity: 0 }} className="client-note">
                          <div className="note-tooltip-wrapper">
                            <div className="div-block-356" />
                            <div className="div-block-357">
                              <div>Boutique Note:</div>
                              <div id="text-table" className="text-table smaller">
                                Completely transform pandemic information via cross functional
                                systems. Proactively harness.
                              </div>
                              <div className="line-bottom-note-container boutique " />
                              <div
                                id="delete"
                                className="w-layout-grid top-buttons-image-element z-index"
                              >
                                <div
                                  data-w-id="073e8027-4c92-1381-c06b-31f08469eefd"
                                  className="delete-symbol"
                                >
                                  <div className="icon smaller w-embed">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      fill="currentcolor"
                                      viewBox="0 0 256 256"
                                    >
                                      <rect width="256" height="256" fill="none" />
                                      <path d="M216,208H115.314l82.33838-82.33887.00489-.00439.00439-.00488L223.999,99.31445A15.99888,15.99888,0,0,0,224,76.68652L179.31348,31.999A16.02162,16.02162,0,0,0,156.68555,32l-120,120.00049a15.95392,15.95392,0,0,0-3.572,5.45654c-.08228.19971-.15162.40283-.21705.60742A15.9896,15.9896,0,0,0,32,163.31348V208a16.01833,16.01833,0,0,0,16,16H216a8,8,0,0,0,0-16ZM168,43.31348,212.68555,88,192,108.68555,147.314,64Z" />
                                    </svg>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    id="w-node-_073e8027-4c92-1381-c06b-31f08469eeff-b74eabf4"
                    className="content"
                  >
                    <div className="text-table red">04</div>
                  </div>
                  <div
                    id="w-node-_073e8027-4c92-1381-c06b-31f08469ef02-b74eabf4"
                    className="content"
                  >
                    <div className="text-table price">$ 30.00</div>
                  </div>
                  <div
                    id="w-node-_073e8027-4c92-1381-c06b-31f08469ef05-b74eabf4"
                    className="content"
                  >
                    <div className="form-block-input w-form">
                      <form
                        id="email-form"
                        name="email-form"
                        data-name="Email Form"
                        method="get"
                        className="form-input select-field"
                      >
                        <div className="select-field-wrapper">
                          <select
                            id="save"
                            name="field-3"
                            data-name="Field 3"
                            className="form-select-field w-select"
                          >
                            <option value="open">Printing</option>
                            <option value="paid">Matting</option>
                            <option value="shipped">Mounting</option>
                            <option value="in production">Framing</option>
                            <option value="Cancelled">Canvas Prod.</option>
                            <option value="on hold">Album Prod.</option>
                            <option value="Another Choice">Ready To Ship</option>
                            <option value="Another Choice">Shipped</option>
                            <option value="Another Choice">Reprint</option>
                            <option value="Another Choice">On Hold</option>
                            <option value="Another Choice">Cancelled</option>
                          </select>
                          <div className="div-block-63">
                            <img
                              src="images/chevron-down-12.svg"
                              loading="lazy"
                              alt=""
                              className="img-icon"
                            />
                          </div>
                        </div>
                      </form>
                      <div className="w-form-done">
                        <div>Thank you! Your submission has been received!</div>
                      </div>
                      <div className="w-form-fail">
                        <div>Oops! Something went wrong while submitting the form.</div>
                      </div>
                    </div>
                  </div>
                  <div
                    id="w-node-_073e8027-4c92-1381-c06b-31f08469ef13-b74eabf4"
                    className="content"
                  >
                    <a
                      href="/lab-orders/unbundled-line-items"
                      aria-label="Unbundled Line Items Link"
                      className="link-block-11 w-inline-block"
                    >
                      <div className="icon w-embed">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="currentcolor"
                          viewBox="0 0 256 256"
                        >
                          <rect width="256" height="256" fill="none" />
                          <path d="M213.58936,82.2749,157.65723,26.34277c-.08008-.08007-.167-.15039-.25-.22656-.10791-.09912-.21289-.20166-.32618-.29492-.07519-.06152-.15576-.11524-.23291-.17432-.13085-.10009-.26025-.20166-.397-.29394-.062-.04151-.12793-.07617-.19043-.11573-.15869-.10009-.31738-.1997-.4834-.28906-.04492-.02392-.09179-.04248-.13672-.06543-.1875-.09668-.377-.18945-.57275-.271-.03027-.0127-.0625-.022-.09326-.03418-.21045-.08448-.42383-.16358-.64258-.23-.03174-.00977-.06445-.01563-.09619-.02491-.2168-.063-.436-.12109-.66064-.166-.07129-.01416-.145-.02051-.2168-.03272-.18555-.03222-.37012-.06494-.55908-.08349A7.91349,7.91349,0,0,0,152,24H55.99219a16.01833,16.01833,0,0,0-16,16V216a16.01833,16.01833,0,0,0,16,16H200a16.01833,16.01833,0,0,0,16-16V88.15479c.001-.05225.00781-.10254.00781-.15479A7.97147,7.97147,0,0,0,213.58936,82.2749Zm-51.93262,79.38233-28,28c-.023.02313-.04883.04223-.07178.06506-.165.16089-.33447.317-.51269.46326-.09766.08032-.20118.15039-.30176.22534-.1084.08111-.21485.1654-.32764.241-.11621.07794-.2373.1455-.35693.21667-.10449.06244-.20655.12817-.31446.18585-.12011.06439-.24414.119-.36669.17676-.11426.05389-.22657.1109-.34327.15942-.11816.049-.23925.08838-.35937.13135-.126.04541-.251.09387-.37988.133-.11963.03613-.24122.06262-.36231.09308-.13184.03338-.26269.07037-.397.097-.13965.02765-.28028.044-.42041.06415-.11817.01691-.23389.03925-.353.051C128.52686,191.986,128.26367,192,128,192s-.52686-.014-.78955-.03986c-.11914-.01171-.23486-.03405-.353-.051-.14013-.02014-.28076-.0365-.42041-.06415-.13428-.02667-.26513-.06366-.397-.097-.12109-.03046-.24268-.057-.36231-.09308-.1289-.03913-.2539-.08759-.37988-.133-.12012-.043-.24121-.0824-.35937-.13135-.1167-.04852-.229-.10553-.34327-.15942-.12255-.0578-.24658-.11237-.36669-.17676-.10791-.05768-.21-.12341-.31446-.18585-.11963-.07117-.24072-.13873-.35693-.21667-.11279-.07557-.21924-.15986-.32764-.241-.10058-.075-.2041-.145-.30176-.22534-.1748-.14374-.3413-.29718-.50341-.455-.02637-.02563-.05518-.04724-.08106-.0733l-28-28a8,8,0,0,1,11.31348-11.314L120,164.68652V120a8,8,0,0,1,16,0v44.68652l14.34326-14.34326a8,8,0,0,1,11.31348,11.314ZM152,88V43.31348L196.68555,88Z" />
                        </svg>
                      </div>
                    </a>
                  </div>
                </div>
                <div
                  id="w-node-d84cddff-ee81-b242-c70f-81ca6af41b03-b74eabf4"
                  className="w-layout-grid grid-element-order-summary unbundled-list"
                >
                  <div
                    id="w-node-d84cddff-ee81-b242-c70f-81ca6af41b04-b74eabf4"
                    className="content"
                  >
                    <div className="form-block-7 w-form">
                      <form
                        id="email-form-4"
                        name="email-form-4"
                        data-name="Email Form 4"
                        method="get"
                      >
                        <label className="w-checkbox checkbox-field-3">
                          <div className="w-checkbox-input w-checkbox-input--inputType-custom checkbox-4 " />
                          <input
                            type="checkbox"
                            id="checkbox-8"
                            name="checkbox-8"
                            data-name="Checkbox 8"
                            style={{ opacity: 0, position: 'absolute', zIndex: -1 }}
                          />
                          <span className="checkbox-label-2 w-form-label" htmlFor="checkbox-8">
                            Checkbox 8
                          </span>
                        </label>
                      </form>
                      <div className="w-form-done">
                        <div>Thank you! Your submission has been received!</div>
                      </div>
                      <div className="w-form-fail">
                        <div>Oops! Something went wrong while submitting the form.</div>
                      </div>
                    </div>
                  </div>
                  <div
                    id="w-node-d84cddff-ee81-b242-c70f-81ca6af41b11-b74eabf4"
                    className="content"
                  >
                    <div className="w-layout-grid grid-90">
                      <div data-tippy-content="mounting" className="dot bigger mounting tippy">
                        <div>MNT</div>
                      </div>
                      <div className="dot bigger paper">
                        <div>PM</div>
                      </div>
                    </div>
                  </div>
                  <div
                    id="w-node-d84cddff-ee81-b242-c70f-81ca6af41b19-b74eabf4"
                    className="content"
                  >
                    <div className="div-block-136">
                      <a
                        href="/lab-orders/unbundled-line-items"
                        aria-label="Unbundled Line Items Link"
                        className="w-inline-block w-lightbox"
                      >
                        <img
                          src="images/default-placeholder.jpg"
                          loading="lazy"
                          srcSet="images/default-placeholder-p-500.jpeg 500w, images/default-placeholder-p-800.jpeg 800w, images/default-placeholder-p-1080.jpeg 1080w, images/default-placeholder.jpg 1500w"
                          sizes="(max-width: 479px) 50px, (max-width: 1279px) 80px, 90px"
                          alt=""
                          className="img-order-summary bigger"
                        />
                      </a>
                    </div>
                  </div>
                  <div className="content print-details unbundled-list">
                    <div className="div-block-350">
                      <div className="grey darker">&quot;Sample&quot;</div>
                      <div>Canson Rag 8x8</div>
                      <div className="w-layout-grid grid-23 main align-left">
                        <div className="icon smaller w-embed">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="currentcolor"
                            viewBox="0 0 256 256"
                          >
                            <rect width="256" height="256" fill="none" />
                            <path d="M209.65479,122.3418a8,8,0,0,1-.00733,11.31347l-82.05322,81.94629a56.00006,56.00006,0,0,1-79.1919-79.20019L147.6709,35.751A39.99954,39.99954,0,1,1,204.27832,92.2793l-99.269,100.65136A23.99954,23.99954,0,1,1,71.02979,159.0293L154.291,74.38477a8.0001,8.0001,0,0,1,11.40625,11.2207L82.38965,170.29688a8,8,0,1,0,11.2666,11.36035L192.92578,81.00488a23.99971,23.99971,0,1,0-33.90185-33.97949L59.75488,147.67578a40.00024,40.00024,0,1,0,56.5293,56.6084L198.34082,122.335A7.99885,7.99885,0,0,1,209.65479,122.3418Z" />
                          </svg>
                        </div>
                        <div>name-file.jpg</div>
                      </div>
                      <a href="admin-order-details.html" className="link-block-12 w-inline-block">
                        <div className="w-layout-grid grid-23 main no-padding">
                          <div>MUS-123XYZ</div>
                          <div className="icon smaller w-embed">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              fill="currentcolor"
                              viewBox="0 0 256 256"
                            >
                              <rect width="256" height="256" fill="none" />
                              <line
                                x1="64"
                                y1="192"
                                x2="192"
                                y2="64"
                                fill="none"
                                stroke="currentcolor"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="16"
                              />
                              <polyline
                                points="88 64 192 64 192 168"
                                fill="none"
                                stroke="currentcolor"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="16"
                              />
                            </svg>
                          </div>
                        </div>
                      </a>
                    </div>
                  </div>
                  <div className="content">
                    <div className="text-table-top-container">
                      <div className="text-table _12px semi-bold">Venetian Silver</div>
                      <div className="text-table _12px semi-bold">2&quot; Mat</div>
                      <div className="text-table _12px semi-bold">Standard Acrylic</div>
                    </div>
                  </div>
                  <div className="content">
                    <div className="div-block-357-copy">
                      <div id="text-table" className="text-table smaller red">
                        Completely transform pandemic information via cross functional systems.
                        Proactively harness.
                      </div>
                      <div id="delete" className="w-layout-grid top-buttons-image-element z-index">
                        <div
                          data-w-id="d84cddff-ee81-b242-c70f-81ca6af41b39"
                          className="delete-symbol no-margin"
                        >
                          <div className="icon smaller w-embed">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              fill="currentcolor"
                              viewBox="0 0 256 256"
                            >
                              <rect width="256" height="256" fill="none" />
                              <path d="M216,208H115.314l82.33838-82.33887.00489-.00439.00439-.00488L223.999,99.31445A15.99888,15.99888,0,0,0,224,76.68652L179.31348,31.999A16.02162,16.02162,0,0,0,156.68555,32l-120,120.00049a15.95392,15.95392,0,0,0-3.572,5.45654c-.08228.19971-.15162.40283-.21705.60742A15.9896,15.9896,0,0,0,32,163.31348V208a16.01833,16.01833,0,0,0,16,16H216a8,8,0,0,0,0-16ZM168,43.31348,212.68555,88,192,108.68555,147.314,64Z" />
                            </svg>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="w-layout-grid grid-93">
                      <div
                        data-w-id="d84cddff-ee81-b242-c70f-81ca6af41b3c"
                        className="note-tooltip"
                      >
                        <div className="icon small x2 w-embed">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="currentcolor"
                            viewBox="0 0 256 256"
                          >
                            <rect width="256" height="256" fill="none" />
                            <path d="M208,32H48A16.01081,16.01081,0,0,0,32,48V208a16.01081,16.01081,0,0,0,16,16H156.6875A15.92313,15.92313,0,0,0,168,219.3125L219.3125,168A15.92313,15.92313,0,0,0,224,156.6875V48A16.01081,16.01081,0,0,0,208,32ZM96,88h64a8,8,0,0,1,0,16H96a8,8,0,0,1,0-16Zm32,80H96a8,8,0,0,1,0-16h32a8,8,0,0,1,0,16ZM96,136a8,8,0,0,1,0-16h64a8,8,0,0,1,0,16Zm64,68.6875V159.98438h44.70312Z" />
                          </svg>
                        </div>
                        <div className="div-block-354">
                          <div>C</div>
                        </div>
                        <div style={{ opacity: 0 }} className="client-note">
                          <div className="note-tooltip-wrapper">
                            <div className="div-block-356" />
                            <div className="div-block-357">
                              <div>Client Note:</div>
                              <div id="text-table" className="text-table smaller red">
                                Completely transform pandemic information via cross functional
                                systems. Proactively harness.
                              </div>
                              <div className="line-bottom-note-container " />
                              <div
                                id="delete"
                                className="w-layout-grid top-buttons-image-element z-index"
                              >
                                <div
                                  data-w-id="d84cddff-ee81-b242-c70f-81ca6af41b4b"
                                  className="delete-symbol"
                                >
                                  <div className="icon smaller w-embed">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      fill="currentcolor"
                                      viewBox="0 0 256 256"
                                    >
                                      <rect width="256" height="256" fill="none" />
                                      <path d="M216,208H115.314l82.33838-82.33887.00489-.00439.00439-.00488L223.999,99.31445A15.99888,15.99888,0,0,0,224,76.68652L179.31348,31.999A16.02162,16.02162,0,0,0,156.68555,32l-120,120.00049a15.95392,15.95392,0,0,0-3.572,5.45654c-.08228.19971-.15162.40283-.21705.60742A15.9896,15.9896,0,0,0,32,163.31348V208a16.01833,16.01833,0,0,0,16,16H216a8,8,0,0,0,0-16ZM168,43.31348,212.68555,88,192,108.68555,147.314,64Z" />
                                    </svg>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        data-w-id="d84cddff-ee81-b242-c70f-81ca6af41b4d"
                        className="note-tooltip admin"
                      >
                        <div className="icon small x2 w-embed">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="currentcolor"
                            viewBox="0 0 256 256"
                          >
                            <rect width="256" height="256" fill="none" />
                            <path d="M208,32H48A16.01081,16.01081,0,0,0,32,48V208a16.01081,16.01081,0,0,0,16,16H156.6875A15.92313,15.92313,0,0,0,168,219.3125L219.3125,168A15.92313,15.92313,0,0,0,224,156.6875V48A16.01081,16.01081,0,0,0,208,32ZM96,88h64a8,8,0,0,1,0,16H96a8,8,0,0,1,0-16Zm32,80H96a8,8,0,0,1,0-16h32a8,8,0,0,1,0,16ZM96,136a8,8,0,0,1,0-16h64a8,8,0,0,1,0,16Zm64,68.6875V159.98438h44.70312Z" />
                          </svg>
                        </div>
                        <div className="div-block-354 admin">
                          <div>A</div>
                        </div>
                        <div style={{ opacity: 0 }} className="client-note">
                          <div className="note-tooltip-wrapper">
                            <div className="div-block-356" />
                            <div className="div-block-357">
                              <div>Admin Note:</div>
                              <div id="text-table" className="text-table smaller">
                                Completely transform pandemic information via cross functional
                                systems. Proactively harness.
                              </div>
                              <div className="line-bottom-note-container admin " />
                              <div
                                id="delete"
                                className="w-layout-grid top-buttons-image-element z-index"
                              >
                                <div
                                  data-w-id="d84cddff-ee81-b242-c70f-81ca6af41b5c"
                                  className="delete-symbol"
                                >
                                  <div className="icon smaller w-embed">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      fill="currentcolor"
                                      viewBox="0 0 256 256"
                                    >
                                      <rect width="256" height="256" fill="none" />
                                      <path d="M216,208H115.314l82.33838-82.33887.00489-.00439.00439-.00488L223.999,99.31445A15.99888,15.99888,0,0,0,224,76.68652L179.31348,31.999A16.02162,16.02162,0,0,0,156.68555,32l-120,120.00049a15.95392,15.95392,0,0,0-3.572,5.45654c-.08228.19971-.15162.40283-.21705.60742A15.9896,15.9896,0,0,0,32,163.31348V208a16.01833,16.01833,0,0,0,16,16H216a8,8,0,0,0,0-16ZM168,43.31348,212.68555,88,192,108.68555,147.314,64Z" />
                                    </svg>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        data-w-id="d84cddff-ee81-b242-c70f-81ca6af41b5e"
                        className="note-tooltip boutique"
                      >
                        <div className="icon small x2 w-embed">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="currentcolor"
                            viewBox="0 0 256 256"
                          >
                            <rect width="256" height="256" fill="none" />
                            <path d="M208,32H48A16.01081,16.01081,0,0,0,32,48V208a16.01081,16.01081,0,0,0,16,16H156.6875A15.92313,15.92313,0,0,0,168,219.3125L219.3125,168A15.92313,15.92313,0,0,0,224,156.6875V48A16.01081,16.01081,0,0,0,208,32ZM96,88h64a8,8,0,0,1,0,16H96a8,8,0,0,1,0-16Zm32,80H96a8,8,0,0,1,0-16h32a8,8,0,0,1,0,16ZM96,136a8,8,0,0,1,0-16h64a8,8,0,0,1,0,16Zm64,68.6875V159.98438h44.70312Z" />
                          </svg>
                        </div>
                        <div className="div-block-354 boutique">
                          <div>B</div>
                        </div>
                        <div style={{ opacity: 0 }} className="client-note">
                          <div className="note-tooltip-wrapper">
                            <div className="div-block-356" />
                            <div className="div-block-357">
                              <div>Boutique Note:</div>
                              <div id="text-table" className="text-table smaller">
                                Completely transform pandemic information via cross functional
                                systems. Proactively harness.
                              </div>
                              <div className="line-bottom-note-container boutique " />
                              <div
                                id="delete"
                                className="w-layout-grid top-buttons-image-element z-index"
                              >
                                <div
                                  data-w-id="d84cddff-ee81-b242-c70f-81ca6af41b6d"
                                  className="delete-symbol"
                                >
                                  <div className="icon smaller w-embed">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      fill="currentcolor"
                                      viewBox="0 0 256 256"
                                    >
                                      <rect width="256" height="256" fill="none" />
                                      <path d="M216,208H115.314l82.33838-82.33887.00489-.00439.00439-.00488L223.999,99.31445A15.99888,15.99888,0,0,0,224,76.68652L179.31348,31.999A16.02162,16.02162,0,0,0,156.68555,32l-120,120.00049a15.95392,15.95392,0,0,0-3.572,5.45654c-.08228.19971-.15162.40283-.21705.60742A15.9896,15.9896,0,0,0,32,163.31348V208a16.01833,16.01833,0,0,0,16,16H216a8,8,0,0,0,0-16ZM168,43.31348,212.68555,88,192,108.68555,147.314,64Z" />
                                    </svg>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    id="w-node-d84cddff-ee81-b242-c70f-81ca6af41b6f-b74eabf4"
                    className="content"
                  >
                    <div className="text-table red">04</div>
                  </div>
                  <div
                    id="w-node-d84cddff-ee81-b242-c70f-81ca6af41b72-b74eabf4"
                    className="content"
                  >
                    <div className="text-table price">$ 30.00</div>
                  </div>
                  <div
                    id="w-node-d84cddff-ee81-b242-c70f-81ca6af41b75-b74eabf4"
                    className="content"
                  >
                    <div className="form-block-input w-form">
                      <form
                        id="email-form"
                        name="email-form"
                        data-name="Email Form"
                        method="get"
                        className="form-input select-field"
                      >
                        <div className="select-field-wrapper">
                          <select
                            id="save"
                            name="field-3"
                            data-name="Field 3"
                            className="form-select-field w-select"
                          >
                            <option value="open">Printing</option>
                            <option value="paid">Matting</option>
                            <option value="shipped">Mounting</option>
                            <option value="in production">Framing</option>
                            <option value="Cancelled">Canvas Prod.</option>
                            <option value="on hold">Album Prod.</option>
                            <option value="Another Choice">Ready To Ship</option>
                            <option value="Another Choice">Shipped</option>
                            <option value="Another Choice">Reprint</option>
                            <option value="Another Choice">On Hold</option>
                            <option value="Another Choice">Cancelled</option>
                          </select>
                          <div className="div-block-63">
                            <img
                              src="images/chevron-down-12.svg"
                              loading="lazy"
                              alt=""
                              className="img-icon"
                            />
                          </div>
                        </div>
                      </form>
                      <div className="w-form-done">
                        <div>Thank you! Your submission has been received!</div>
                      </div>
                      <div className="w-form-fail">
                        <div>Oops! Something went wrong while submitting the form.</div>
                      </div>
                    </div>
                  </div>
                  <div
                    id="w-node-d84cddff-ee81-b242-c70f-81ca6af41b83-b74eabf4"
                    className="content"
                  >
                    <a
                      href="/lab-orders/unbundled-line-items"
                      aria-label="Unbundled Line Items Link"
                      className="link-block-11 w-inline-block"
                    >
                      <div className="icon w-embed">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="currentcolor"
                          viewBox="0 0 256 256"
                        >
                          <rect width="256" height="256" fill="none" />
                          <path d="M213.58936,82.2749,157.65723,26.34277c-.08008-.08007-.167-.15039-.25-.22656-.10791-.09912-.21289-.20166-.32618-.29492-.07519-.06152-.15576-.11524-.23291-.17432-.13085-.10009-.26025-.20166-.397-.29394-.062-.04151-.12793-.07617-.19043-.11573-.15869-.10009-.31738-.1997-.4834-.28906-.04492-.02392-.09179-.04248-.13672-.06543-.1875-.09668-.377-.18945-.57275-.271-.03027-.0127-.0625-.022-.09326-.03418-.21045-.08448-.42383-.16358-.64258-.23-.03174-.00977-.06445-.01563-.09619-.02491-.2168-.063-.436-.12109-.66064-.166-.07129-.01416-.145-.02051-.2168-.03272-.18555-.03222-.37012-.06494-.55908-.08349A7.91349,7.91349,0,0,0,152,24H55.99219a16.01833,16.01833,0,0,0-16,16V216a16.01833,16.01833,0,0,0,16,16H200a16.01833,16.01833,0,0,0,16-16V88.15479c.001-.05225.00781-.10254.00781-.15479A7.97147,7.97147,0,0,0,213.58936,82.2749Zm-51.93262,79.38233-28,28c-.023.02313-.04883.04223-.07178.06506-.165.16089-.33447.317-.51269.46326-.09766.08032-.20118.15039-.30176.22534-.1084.08111-.21485.1654-.32764.241-.11621.07794-.2373.1455-.35693.21667-.10449.06244-.20655.12817-.31446.18585-.12011.06439-.24414.119-.36669.17676-.11426.05389-.22657.1109-.34327.15942-.11816.049-.23925.08838-.35937.13135-.126.04541-.251.09387-.37988.133-.11963.03613-.24122.06262-.36231.09308-.13184.03338-.26269.07037-.397.097-.13965.02765-.28028.044-.42041.06415-.11817.01691-.23389.03925-.353.051C128.52686,191.986,128.26367,192,128,192s-.52686-.014-.78955-.03986c-.11914-.01171-.23486-.03405-.353-.051-.14013-.02014-.28076-.0365-.42041-.06415-.13428-.02667-.26513-.06366-.397-.097-.12109-.03046-.24268-.057-.36231-.09308-.1289-.03913-.2539-.08759-.37988-.133-.12012-.043-.24121-.0824-.35937-.13135-.1167-.04852-.229-.10553-.34327-.15942-.12255-.0578-.24658-.11237-.36669-.17676-.10791-.05768-.21-.12341-.31446-.18585-.11963-.07117-.24072-.13873-.35693-.21667-.11279-.07557-.21924-.15986-.32764-.241-.10058-.075-.2041-.145-.30176-.22534-.1748-.14374-.3413-.29718-.50341-.455-.02637-.02563-.05518-.04724-.08106-.0733l-28-28a8,8,0,0,1,11.31348-11.314L120,164.68652V120a8,8,0,0,1,16,0v44.68652l14.34326-14.34326a8,8,0,0,1,11.31348,11.314ZM152,88V43.31348L196.68555,88Z" />
                        </svg>
                      </div>
                    </a>
                  </div>
                </div>
                <div
                  id="w-node-_3227de94-9f9d-7523-c28b-03bb1e5559b7-b74eabf4"
                  className="w-layout-grid grid-element-order-summary unbundled-list"
                >
                  <div
                    id="w-node-_3227de94-9f9d-7523-c28b-03bb1e5559b8-b74eabf4"
                    className="content"
                  >
                    <div className="form-block-7 w-form">
                      <form
                        id="email-form-4"
                        name="email-form-4"
                        data-name="Email Form 4"
                        method="get"
                      >
                        <label className="w-checkbox checkbox-field-3">
                          <div className="w-checkbox-input w-checkbox-input--inputType-custom checkbox-4 " />
                          <input
                            type="checkbox"
                            id="checkbox-8"
                            name="checkbox-8"
                            data-name="Checkbox 8"
                            style={{ opacity: 0, position: 'absolute', zIndex: -1 }}
                          />
                          <span className="checkbox-label-2 w-form-label" htmlFor="checkbox-8">
                            Checkbox 8
                          </span>
                        </label>
                      </form>
                      <div className="w-form-done">
                        <div>Thank you! Your submission has been received!</div>
                      </div>
                      <div className="w-form-fail">
                        <div>Oops! Something went wrong while submitting the form.</div>
                      </div>
                    </div>
                  </div>
                  <div
                    id="w-node-_3227de94-9f9d-7523-c28b-03bb1e5559c5-b74eabf4"
                    className="content"
                  >
                    <div className="w-layout-grid grid-90">
                      <div data-tippy-content="mounting" className="dot bigger mounting tippy">
                        <div>MNT</div>
                      </div>
                      <div className="dot bigger paper">
                        <div>PM</div>
                      </div>
                    </div>
                  </div>
                  <div
                    id="w-node-_3227de94-9f9d-7523-c28b-03bb1e5559cd-b74eabf4"
                    className="content"
                  >
                    <div className="div-block-136">
                      <a
                        href="/lab-orders/unbundled-line-items"
                        aria-label="Unbundled Line Items Link"
                        className="w-inline-block w-lightbox"
                      >
                        <img
                          src="images/default-placeholder.jpg"
                          loading="lazy"
                          srcSet="images/default-placeholder-p-500.jpeg 500w, images/default-placeholder-p-800.jpeg 800w, images/default-placeholder-p-1080.jpeg 1080w, images/default-placeholder.jpg 1500w"
                          sizes="(max-width: 479px) 50px, (max-width: 1279px) 80px, 90px"
                          alt=""
                          className="img-order-summary bigger"
                        />
                      </a>
                    </div>
                  </div>
                  <div className="content print-details unbundled-list">
                    <div className="div-block-350">
                      <div className="grey darker">&quot;Sample&quot;</div>
                      <div>Canson Rag 8x8</div>
                      <div className="w-layout-grid grid-23 main align-left">
                        <div className="icon smaller w-embed">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="currentcolor"
                            viewBox="0 0 256 256"
                          >
                            <rect width="256" height="256" fill="none" />
                            <path d="M209.65479,122.3418a8,8,0,0,1-.00733,11.31347l-82.05322,81.94629a56.00006,56.00006,0,0,1-79.1919-79.20019L147.6709,35.751A39.99954,39.99954,0,1,1,204.27832,92.2793l-99.269,100.65136A23.99954,23.99954,0,1,1,71.02979,159.0293L154.291,74.38477a8.0001,8.0001,0,0,1,11.40625,11.2207L82.38965,170.29688a8,8,0,1,0,11.2666,11.36035L192.92578,81.00488a23.99971,23.99971,0,1,0-33.90185-33.97949L59.75488,147.67578a40.00024,40.00024,0,1,0,56.5293,56.6084L198.34082,122.335A7.99885,7.99885,0,0,1,209.65479,122.3418Z" />
                          </svg>
                        </div>
                        <div>name-file.jpg</div>
                      </div>
                      <a href="admin-order-details.html" className="link-block-12 w-inline-block">
                        <div className="w-layout-grid grid-23 main no-padding">
                          <div>MUS-123XYZ</div>
                          <div className="icon smaller w-embed">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              fill="currentcolor"
                              viewBox="0 0 256 256"
                            >
                              <rect width="256" height="256" fill="none" />
                              <line
                                x1="64"
                                y1="192"
                                x2="192"
                                y2="64"
                                fill="none"
                                stroke="currentcolor"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="16"
                              />
                              <polyline
                                points="88 64 192 64 192 168"
                                fill="none"
                                stroke="currentcolor"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="16"
                              />
                            </svg>
                          </div>
                        </div>
                      </a>
                    </div>
                  </div>
                  <div className="content">
                    <div className="text-table-top-container">
                      <div className="text-table _12px semi-bold">Venetian Silver</div>
                      <div className="text-table _12px semi-bold">2&quot; Mat</div>
                      <div className="text-table _12px semi-bold">Standard Acrylic</div>
                    </div>
                  </div>
                  <div className="content">
                    <div className="div-block-357-copy">
                      <div id="text-table" className="text-table smaller red">
                        Completely transform pandemic information via cross functional systems.
                        Proactively harness.
                      </div>
                      <div id="delete" className="w-layout-grid top-buttons-image-element z-index">
                        <div
                          data-w-id="3227de94-9f9d-7523-c28b-03bb1e5559ed"
                          className="delete-symbol no-margin"
                        >
                          <div className="icon smaller w-embed">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              fill="currentcolor"
                              viewBox="0 0 256 256"
                            >
                              <rect width="256" height="256" fill="none" />
                              <path d="M216,208H115.314l82.33838-82.33887.00489-.00439.00439-.00488L223.999,99.31445A15.99888,15.99888,0,0,0,224,76.68652L179.31348,31.999A16.02162,16.02162,0,0,0,156.68555,32l-120,120.00049a15.95392,15.95392,0,0,0-3.572,5.45654c-.08228.19971-.15162.40283-.21705.60742A15.9896,15.9896,0,0,0,32,163.31348V208a16.01833,16.01833,0,0,0,16,16H216a8,8,0,0,0,0-16ZM168,43.31348,212.68555,88,192,108.68555,147.314,64Z" />
                            </svg>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="w-layout-grid grid-93">
                      <div
                        data-w-id="3227de94-9f9d-7523-c28b-03bb1e5559f0"
                        className="note-tooltip"
                      >
                        <div className="icon small x2 w-embed">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="currentcolor"
                            viewBox="0 0 256 256"
                          >
                            <rect width="256" height="256" fill="none" />
                            <path d="M208,32H48A16.01081,16.01081,0,0,0,32,48V208a16.01081,16.01081,0,0,0,16,16H156.6875A15.92313,15.92313,0,0,0,168,219.3125L219.3125,168A15.92313,15.92313,0,0,0,224,156.6875V48A16.01081,16.01081,0,0,0,208,32ZM96,88h64a8,8,0,0,1,0,16H96a8,8,0,0,1,0-16Zm32,80H96a8,8,0,0,1,0-16h32a8,8,0,0,1,0,16ZM96,136a8,8,0,0,1,0-16h64a8,8,0,0,1,0,16Zm64,68.6875V159.98438h44.70312Z" />
                          </svg>
                        </div>
                        <div className="div-block-354">
                          <div>C</div>
                        </div>
                        <div style={{ opacity: 0 }} className="client-note">
                          <div className="note-tooltip-wrapper">
                            <div className="div-block-356" />
                            <div className="div-block-357">
                              <div>Client Note:</div>
                              <div id="text-table" className="text-table smaller red">
                                Completely transform pandemic information via cross functional
                                systems. Proactively harness.
                              </div>
                              <div className="line-bottom-note-container " />
                              <div
                                id="delete"
                                className="w-layout-grid top-buttons-image-element z-index"
                              >
                                <div
                                  data-w-id="3227de94-9f9d-7523-c28b-03bb1e5559ff"
                                  className="delete-symbol"
                                >
                                  <div className="icon smaller w-embed">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      fill="currentcolor"
                                      viewBox="0 0 256 256"
                                    >
                                      <rect width="256" height="256" fill="none" />
                                      <path d="M216,208H115.314l82.33838-82.33887.00489-.00439.00439-.00488L223.999,99.31445A15.99888,15.99888,0,0,0,224,76.68652L179.31348,31.999A16.02162,16.02162,0,0,0,156.68555,32l-120,120.00049a15.95392,15.95392,0,0,0-3.572,5.45654c-.08228.19971-.15162.40283-.21705.60742A15.9896,15.9896,0,0,0,32,163.31348V208a16.01833,16.01833,0,0,0,16,16H216a8,8,0,0,0,0-16ZM168,43.31348,212.68555,88,192,108.68555,147.314,64Z" />
                                    </svg>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        data-w-id="3227de94-9f9d-7523-c28b-03bb1e555a01"
                        className="note-tooltip admin"
                      >
                        <div className="icon small x2 w-embed">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="currentcolor"
                            viewBox="0 0 256 256"
                          >
                            <rect width="256" height="256" fill="none" />
                            <path d="M208,32H48A16.01081,16.01081,0,0,0,32,48V208a16.01081,16.01081,0,0,0,16,16H156.6875A15.92313,15.92313,0,0,0,168,219.3125L219.3125,168A15.92313,15.92313,0,0,0,224,156.6875V48A16.01081,16.01081,0,0,0,208,32ZM96,88h64a8,8,0,0,1,0,16H96a8,8,0,0,1,0-16Zm32,80H96a8,8,0,0,1,0-16h32a8,8,0,0,1,0,16ZM96,136a8,8,0,0,1,0-16h64a8,8,0,0,1,0,16Zm64,68.6875V159.98438h44.70312Z" />
                          </svg>
                        </div>
                        <div className="div-block-354 admin">
                          <div>A</div>
                        </div>
                        <div style={{ opacity: 0 }} className="client-note">
                          <div className="note-tooltip-wrapper">
                            <div className="div-block-356" />
                            <div className="div-block-357">
                              <div>Admin Note:</div>
                              <div id="text-table" className="text-table smaller">
                                Completely transform pandemic information via cross functional
                                systems. Proactively harness.
                              </div>
                              <div className="line-bottom-note-container admin " />
                              <div
                                id="delete"
                                className="w-layout-grid top-buttons-image-element z-index"
                              >
                                <div
                                  data-w-id="3227de94-9f9d-7523-c28b-03bb1e555a10"
                                  className="delete-symbol"
                                >
                                  <div className="icon smaller w-embed">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      fill="currentcolor"
                                      viewBox="0 0 256 256"
                                    >
                                      <rect width="256" height="256" fill="none" />
                                      <path d="M216,208H115.314l82.33838-82.33887.00489-.00439.00439-.00488L223.999,99.31445A15.99888,15.99888,0,0,0,224,76.68652L179.31348,31.999A16.02162,16.02162,0,0,0,156.68555,32l-120,120.00049a15.95392,15.95392,0,0,0-3.572,5.45654c-.08228.19971-.15162.40283-.21705.60742A15.9896,15.9896,0,0,0,32,163.31348V208a16.01833,16.01833,0,0,0,16,16H216a8,8,0,0,0,0-16ZM168,43.31348,212.68555,88,192,108.68555,147.314,64Z" />
                                    </svg>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        data-w-id="3227de94-9f9d-7523-c28b-03bb1e555a12"
                        className="note-tooltip boutique"
                      >
                        <div className="icon small x2 w-embed">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="currentcolor"
                            viewBox="0 0 256 256"
                          >
                            <rect width="256" height="256" fill="none" />
                            <path d="M208,32H48A16.01081,16.01081,0,0,0,32,48V208a16.01081,16.01081,0,0,0,16,16H156.6875A15.92313,15.92313,0,0,0,168,219.3125L219.3125,168A15.92313,15.92313,0,0,0,224,156.6875V48A16.01081,16.01081,0,0,0,208,32ZM96,88h64a8,8,0,0,1,0,16H96a8,8,0,0,1,0-16Zm32,80H96a8,8,0,0,1,0-16h32a8,8,0,0,1,0,16ZM96,136a8,8,0,0,1,0-16h64a8,8,0,0,1,0,16Zm64,68.6875V159.98438h44.70312Z" />
                          </svg>
                        </div>
                        <div className="div-block-354 boutique">
                          <div>B</div>
                        </div>
                        <div style={{ opacity: 0 }} className="client-note">
                          <div className="note-tooltip-wrapper">
                            <div className="div-block-356" />
                            <div className="div-block-357">
                              <div>Boutique Note:</div>
                              <div id="text-table" className="text-table smaller">
                                Completely transform pandemic information via cross functional
                                systems. Proactively harness.
                              </div>
                              <div className="line-bottom-note-container boutique " />
                              <div
                                id="delete"
                                className="w-layout-grid top-buttons-image-element z-index"
                              >
                                <div
                                  data-w-id="3227de94-9f9d-7523-c28b-03bb1e555a21"
                                  className="delete-symbol"
                                >
                                  <div className="icon smaller w-embed">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      fill="currentcolor"
                                      viewBox="0 0 256 256"
                                    >
                                      <rect width="256" height="256" fill="none" />
                                      <path d="M216,208H115.314l82.33838-82.33887.00489-.00439.00439-.00488L223.999,99.31445A15.99888,15.99888,0,0,0,224,76.68652L179.31348,31.999A16.02162,16.02162,0,0,0,156.68555,32l-120,120.00049a15.95392,15.95392,0,0,0-3.572,5.45654c-.08228.19971-.15162.40283-.21705.60742A15.9896,15.9896,0,0,0,32,163.31348V208a16.01833,16.01833,0,0,0,16,16H216a8,8,0,0,0,0-16ZM168,43.31348,212.68555,88,192,108.68555,147.314,64Z" />
                                    </svg>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    id="w-node-_3227de94-9f9d-7523-c28b-03bb1e555a23-b74eabf4"
                    className="content"
                  >
                    <div className="text-table red">04</div>
                  </div>
                  <div
                    id="w-node-_3227de94-9f9d-7523-c28b-03bb1e555a26-b74eabf4"
                    className="content"
                  >
                    <div className="text-table price">$ 30.00</div>
                  </div>
                  <div
                    id="w-node-_3227de94-9f9d-7523-c28b-03bb1e555a29-b74eabf4"
                    className="content"
                  >
                    <div className="form-block-input w-form">
                      <form
                        id="email-form"
                        name="email-form"
                        data-name="Email Form"
                        method="get"
                        className="form-input select-field"
                      >
                        <div className="select-field-wrapper">
                          <select
                            id="save"
                            name="field-3"
                            data-name="Field 3"
                            className="form-select-field w-select"
                          >
                            <option value="open">Printing</option>
                            <option value="paid">Matting</option>
                            <option value="shipped">Mounting</option>
                            <option value="in production">Framing</option>
                            <option value="Cancelled">Canvas Prod.</option>
                            <option value="on hold">Album Prod.</option>
                            <option value="Another Choice">Ready To Ship</option>
                            <option value="Another Choice">Shipped</option>
                            <option value="Another Choice">Reprint</option>
                            <option value="Another Choice">On Hold</option>
                            <option value="Another Choice">Cancelled</option>
                          </select>
                          <div className="div-block-63">
                            <img
                              src="images/chevron-down-12.svg"
                              loading="lazy"
                              alt=""
                              className="img-icon"
                            />
                          </div>
                        </div>
                      </form>
                      <div className="w-form-done">
                        <div>Thank you! Your submission has been received!</div>
                      </div>
                      <div className="w-form-fail">
                        <div>Oops! Something went wrong while submitting the form.</div>
                      </div>
                    </div>
                  </div>
                  <div
                    id="w-node-_3227de94-9f9d-7523-c28b-03bb1e555a37-b74eabf4"
                    className="content"
                  >
                    <a
                      href="/lab-orders/unbundled-line-items"
                      aria-label="Unbundled Line Items Link"
                      className="link-block-11 w-inline-block"
                    >
                      <div className="icon w-embed">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="currentcolor"
                          viewBox="0 0 256 256"
                        >
                          <rect width="256" height="256" fill="none" />
                          <path d="M213.58936,82.2749,157.65723,26.34277c-.08008-.08007-.167-.15039-.25-.22656-.10791-.09912-.21289-.20166-.32618-.29492-.07519-.06152-.15576-.11524-.23291-.17432-.13085-.10009-.26025-.20166-.397-.29394-.062-.04151-.12793-.07617-.19043-.11573-.15869-.10009-.31738-.1997-.4834-.28906-.04492-.02392-.09179-.04248-.13672-.06543-.1875-.09668-.377-.18945-.57275-.271-.03027-.0127-.0625-.022-.09326-.03418-.21045-.08448-.42383-.16358-.64258-.23-.03174-.00977-.06445-.01563-.09619-.02491-.2168-.063-.436-.12109-.66064-.166-.07129-.01416-.145-.02051-.2168-.03272-.18555-.03222-.37012-.06494-.55908-.08349A7.91349,7.91349,0,0,0,152,24H55.99219a16.01833,16.01833,0,0,0-16,16V216a16.01833,16.01833,0,0,0,16,16H200a16.01833,16.01833,0,0,0,16-16V88.15479c.001-.05225.00781-.10254.00781-.15479A7.97147,7.97147,0,0,0,213.58936,82.2749Zm-51.93262,79.38233-28,28c-.023.02313-.04883.04223-.07178.06506-.165.16089-.33447.317-.51269.46326-.09766.08032-.20118.15039-.30176.22534-.1084.08111-.21485.1654-.32764.241-.11621.07794-.2373.1455-.35693.21667-.10449.06244-.20655.12817-.31446.18585-.12011.06439-.24414.119-.36669.17676-.11426.05389-.22657.1109-.34327.15942-.11816.049-.23925.08838-.35937.13135-.126.04541-.251.09387-.37988.133-.11963.03613-.24122.06262-.36231.09308-.13184.03338-.26269.07037-.397.097-.13965.02765-.28028.044-.42041.06415-.11817.01691-.23389.03925-.353.051C128.52686,191.986,128.26367,192,128,192s-.52686-.014-.78955-.03986c-.11914-.01171-.23486-.03405-.353-.051-.14013-.02014-.28076-.0365-.42041-.06415-.13428-.02667-.26513-.06366-.397-.097-.12109-.03046-.24268-.057-.36231-.09308-.1289-.03913-.2539-.08759-.37988-.133-.12012-.043-.24121-.0824-.35937-.13135-.1167-.04852-.229-.10553-.34327-.15942-.12255-.0578-.24658-.11237-.36669-.17676-.10791-.05768-.21-.12341-.31446-.18585-.11963-.07117-.24072-.13873-.35693-.21667-.11279-.07557-.21924-.15986-.32764-.241-.10058-.075-.2041-.145-.30176-.22534-.1748-.14374-.3413-.29718-.50341-.455-.02637-.02563-.05518-.04724-.08106-.0733l-28-28a8,8,0,0,1,11.31348-11.314L120,164.68652V120a8,8,0,0,1,16,0v44.68652l14.34326-14.34326a8,8,0,0,1,11.31348,11.314ZM152,88V43.31348L196.68555,88Z" />
                        </svg>
                      </div>
                    </a>
                  </div>
                </div>
                <div
                  id="w-node-_1b414107-556a-2e31-911b-d880ac598553-b74eabf4"
                  className="w-layout-grid grid-element-order-summary unbundled-list"
                >
                  <div
                    id="w-node-_1b414107-556a-2e31-911b-d880ac598554-b74eabf4"
                    className="content"
                  >
                    <div className="form-block-7 w-form">
                      <form
                        id="email-form-4"
                        name="email-form-4"
                        data-name="Email Form 4"
                        method="get"
                      >
                        <label className="w-checkbox checkbox-field-3">
                          <div className="w-checkbox-input w-checkbox-input--inputType-custom checkbox-4 " />
                          <input
                            type="checkbox"
                            id="checkbox-8"
                            name="checkbox-8"
                            data-name="Checkbox 8"
                            style={{ opacity: 0, position: 'absolute', zIndex: -1 }}
                          />
                          <span className="checkbox-label-2 w-form-label" htmlFor="checkbox-8">
                            Checkbox 8
                          </span>
                        </label>
                      </form>
                      <div className="w-form-done">
                        <div>Thank you! Your submission has been received!</div>
                      </div>
                      <div className="w-form-fail">
                        <div>Oops! Something went wrong while submitting the form.</div>
                      </div>
                    </div>
                  </div>
                  <div
                    id="w-node-_1b414107-556a-2e31-911b-d880ac598561-b74eabf4"
                    className="content"
                  >
                    <div className="w-layout-grid grid-90">
                      <div data-tippy-content="mounting" className="dot bigger mounting tippy">
                        <div>MNT</div>
                      </div>
                      <div className="dot bigger paper">
                        <div>PM</div>
                      </div>
                    </div>
                  </div>
                  <div
                    id="w-node-_1b414107-556a-2e31-911b-d880ac598569-b74eabf4"
                    className="content"
                  >
                    <div className="div-block-136">
                      <a
                        href="/lab-orders/unbundled-line-items"
                        aria-label="Unbundled Line Items Link"
                        className="w-inline-block w-lightbox"
                      >
                        <img
                          src="images/default-placeholder.jpg"
                          loading="lazy"
                          srcSet="images/default-placeholder-p-500.jpeg 500w, images/default-placeholder-p-800.jpeg 800w, images/default-placeholder-p-1080.jpeg 1080w, images/default-placeholder.jpg 1500w"
                          sizes="(max-width: 479px) 50px, (max-width: 1279px) 80px, 90px"
                          alt=""
                          className="img-order-summary bigger"
                        />
                      </a>
                    </div>
                  </div>
                  <div className="content print-details unbundled-list">
                    <div className="div-block-350">
                      <div className="grey darker">&quot;Sample&quot;</div>
                      <div>Canson Rag 8x8</div>
                      <div className="w-layout-grid grid-23 main align-left">
                        <div className="icon smaller w-embed">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="currentcolor"
                            viewBox="0 0 256 256"
                          >
                            <rect width="256" height="256" fill="none" />
                            <path d="M209.65479,122.3418a8,8,0,0,1-.00733,11.31347l-82.05322,81.94629a56.00006,56.00006,0,0,1-79.1919-79.20019L147.6709,35.751A39.99954,39.99954,0,1,1,204.27832,92.2793l-99.269,100.65136A23.99954,23.99954,0,1,1,71.02979,159.0293L154.291,74.38477a8.0001,8.0001,0,0,1,11.40625,11.2207L82.38965,170.29688a8,8,0,1,0,11.2666,11.36035L192.92578,81.00488a23.99971,23.99971,0,1,0-33.90185-33.97949L59.75488,147.67578a40.00024,40.00024,0,1,0,56.5293,56.6084L198.34082,122.335A7.99885,7.99885,0,0,1,209.65479,122.3418Z" />
                          </svg>
                        </div>
                        <div>name-file.jpg</div>
                      </div>
                      <a href="admin-order-details.html" className="link-block-12 w-inline-block">
                        <div className="w-layout-grid grid-23 main no-padding">
                          <div>MUS-123XYZ</div>
                          <div className="icon smaller w-embed">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              fill="currentcolor"
                              viewBox="0 0 256 256"
                            >
                              <rect width="256" height="256" fill="none" />
                              <line
                                x1="64"
                                y1="192"
                                x2="192"
                                y2="64"
                                fill="none"
                                stroke="currentcolor"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="16"
                              />
                              <polyline
                                points="88 64 192 64 192 168"
                                fill="none"
                                stroke="currentcolor"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="16"
                              />
                            </svg>
                          </div>
                        </div>
                      </a>
                    </div>
                  </div>
                  <div className="content">
                    <div className="text-table-top-container">
                      <div className="text-table _12px semi-bold">Venetian Silver</div>
                      <div className="text-table _12px semi-bold">2&quot; Mat</div>
                      <div className="text-table _12px semi-bold">Standard Acrylic</div>
                    </div>
                  </div>
                  <div className="content">
                    <div className="div-block-357-copy">
                      <div id="text-table" className="text-table smaller red">
                        Completely transform pandemic information via cross functional systems.
                        Proactively harness.
                      </div>
                      <div id="delete" className="w-layout-grid top-buttons-image-element z-index">
                        <div
                          data-w-id="1b414107-556a-2e31-911b-d880ac598589"
                          className="delete-symbol no-margin"
                        >
                          <div className="icon smaller w-embed">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              fill="currentcolor"
                              viewBox="0 0 256 256"
                            >
                              <rect width="256" height="256" fill="none" />
                              <path d="M216,208H115.314l82.33838-82.33887.00489-.00439.00439-.00488L223.999,99.31445A15.99888,15.99888,0,0,0,224,76.68652L179.31348,31.999A16.02162,16.02162,0,0,0,156.68555,32l-120,120.00049a15.95392,15.95392,0,0,0-3.572,5.45654c-.08228.19971-.15162.40283-.21705.60742A15.9896,15.9896,0,0,0,32,163.31348V208a16.01833,16.01833,0,0,0,16,16H216a8,8,0,0,0,0-16ZM168,43.31348,212.68555,88,192,108.68555,147.314,64Z" />
                            </svg>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="w-layout-grid grid-93">
                      <div
                        data-w-id="1b414107-556a-2e31-911b-d880ac59858c"
                        className="note-tooltip"
                      >
                        <div className="icon small x2 w-embed">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="currentcolor"
                            viewBox="0 0 256 256"
                          >
                            <rect width="256" height="256" fill="none" />
                            <path d="M208,32H48A16.01081,16.01081,0,0,0,32,48V208a16.01081,16.01081,0,0,0,16,16H156.6875A15.92313,15.92313,0,0,0,168,219.3125L219.3125,168A15.92313,15.92313,0,0,0,224,156.6875V48A16.01081,16.01081,0,0,0,208,32ZM96,88h64a8,8,0,0,1,0,16H96a8,8,0,0,1,0-16Zm32,80H96a8,8,0,0,1,0-16h32a8,8,0,0,1,0,16ZM96,136a8,8,0,0,1,0-16h64a8,8,0,0,1,0,16Zm64,68.6875V159.98438h44.70312Z" />
                          </svg>
                        </div>
                        <div className="div-block-354">
                          <div>C</div>
                        </div>
                        <div style={{ opacity: 0 }} className="client-note">
                          <div className="note-tooltip-wrapper">
                            <div className="div-block-356" />
                            <div className="div-block-357">
                              <div>Client Note:</div>
                              <div id="text-table" className="text-table smaller red">
                                Completely transform pandemic information via cross functional
                                systems. Proactively harness.
                              </div>
                              <div className="line-bottom-note-container " />
                              <div
                                id="delete"
                                className="w-layout-grid top-buttons-image-element z-index"
                              >
                                <div
                                  data-w-id="1b414107-556a-2e31-911b-d880ac59859b"
                                  className="delete-symbol"
                                >
                                  <div className="icon smaller w-embed">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      fill="currentcolor"
                                      viewBox="0 0 256 256"
                                    >
                                      <rect width="256" height="256" fill="none" />
                                      <path d="M216,208H115.314l82.33838-82.33887.00489-.00439.00439-.00488L223.999,99.31445A15.99888,15.99888,0,0,0,224,76.68652L179.31348,31.999A16.02162,16.02162,0,0,0,156.68555,32l-120,120.00049a15.95392,15.95392,0,0,0-3.572,5.45654c-.08228.19971-.15162.40283-.21705.60742A15.9896,15.9896,0,0,0,32,163.31348V208a16.01833,16.01833,0,0,0,16,16H216a8,8,0,0,0,0-16ZM168,43.31348,212.68555,88,192,108.68555,147.314,64Z" />
                                    </svg>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        data-w-id="1b414107-556a-2e31-911b-d880ac59859d"
                        className="note-tooltip admin"
                      >
                        <div className="icon small x2 w-embed">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="currentcolor"
                            viewBox="0 0 256 256"
                          >
                            <rect width="256" height="256" fill="none" />
                            <path d="M208,32H48A16.01081,16.01081,0,0,0,32,48V208a16.01081,16.01081,0,0,0,16,16H156.6875A15.92313,15.92313,0,0,0,168,219.3125L219.3125,168A15.92313,15.92313,0,0,0,224,156.6875V48A16.01081,16.01081,0,0,0,208,32ZM96,88h64a8,8,0,0,1,0,16H96a8,8,0,0,1,0-16Zm32,80H96a8,8,0,0,1,0-16h32a8,8,0,0,1,0,16ZM96,136a8,8,0,0,1,0-16h64a8,8,0,0,1,0,16Zm64,68.6875V159.98438h44.70312Z" />
                          </svg>
                        </div>
                        <div className="div-block-354 admin">
                          <div>A</div>
                        </div>
                        <div style={{ opacity: 0 }} className="client-note">
                          <div className="note-tooltip-wrapper">
                            <div className="div-block-356" />
                            <div className="div-block-357">
                              <div>Admin Note:</div>
                              <div id="text-table" className="text-table smaller">
                                Completely transform pandemic information via cross functional
                                systems. Proactively harness.
                              </div>
                              <div className="line-bottom-note-container admin " />
                              <div
                                id="delete"
                                className="w-layout-grid top-buttons-image-element z-index"
                              >
                                <div
                                  data-w-id="1b414107-556a-2e31-911b-d880ac5985ac"
                                  className="delete-symbol"
                                >
                                  <div className="icon smaller w-embed">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      fill="currentcolor"
                                      viewBox="0 0 256 256"
                                    >
                                      <rect width="256" height="256" fill="none" />
                                      <path d="M216,208H115.314l82.33838-82.33887.00489-.00439.00439-.00488L223.999,99.31445A15.99888,15.99888,0,0,0,224,76.68652L179.31348,31.999A16.02162,16.02162,0,0,0,156.68555,32l-120,120.00049a15.95392,15.95392,0,0,0-3.572,5.45654c-.08228.19971-.15162.40283-.21705.60742A15.9896,15.9896,0,0,0,32,163.31348V208a16.01833,16.01833,0,0,0,16,16H216a8,8,0,0,0,0-16ZM168,43.31348,212.68555,88,192,108.68555,147.314,64Z" />
                                    </svg>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        data-w-id="1b414107-556a-2e31-911b-d880ac5985ae"
                        className="note-tooltip boutique"
                      >
                        <div className="icon small x2 w-embed">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="currentcolor"
                            viewBox="0 0 256 256"
                          >
                            <rect width="256" height="256" fill="none" />
                            <path d="M208,32H48A16.01081,16.01081,0,0,0,32,48V208a16.01081,16.01081,0,0,0,16,16H156.6875A15.92313,15.92313,0,0,0,168,219.3125L219.3125,168A15.92313,15.92313,0,0,0,224,156.6875V48A16.01081,16.01081,0,0,0,208,32ZM96,88h64a8,8,0,0,1,0,16H96a8,8,0,0,1,0-16Zm32,80H96a8,8,0,0,1,0-16h32a8,8,0,0,1,0,16ZM96,136a8,8,0,0,1,0-16h64a8,8,0,0,1,0,16Zm64,68.6875V159.98438h44.70312Z" />
                          </svg>
                        </div>
                        <div className="div-block-354 boutique">
                          <div>B</div>
                        </div>
                        <div style={{ opacity: 0 }} className="client-note">
                          <div className="note-tooltip-wrapper">
                            <div className="div-block-356" />
                            <div className="div-block-357">
                              <div>Boutique Note:</div>
                              <div id="text-table" className="text-table smaller">
                                Completely transform pandemic information via cross functional
                                systems. Proactively harness.
                              </div>
                              <div className="line-bottom-note-container boutique " />
                              <div
                                id="delete"
                                className="w-layout-grid top-buttons-image-element z-index"
                              >
                                <div
                                  data-w-id="1b414107-556a-2e31-911b-d880ac5985bd"
                                  className="delete-symbol"
                                >
                                  <div className="icon smaller w-embed">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      fill="currentcolor"
                                      viewBox="0 0 256 256"
                                    >
                                      <rect width="256" height="256" fill="none" />
                                      <path d="M216,208H115.314l82.33838-82.33887.00489-.00439.00439-.00488L223.999,99.31445A15.99888,15.99888,0,0,0,224,76.68652L179.31348,31.999A16.02162,16.02162,0,0,0,156.68555,32l-120,120.00049a15.95392,15.95392,0,0,0-3.572,5.45654c-.08228.19971-.15162.40283-.21705.60742A15.9896,15.9896,0,0,0,32,163.31348V208a16.01833,16.01833,0,0,0,16,16H216a8,8,0,0,0,0-16ZM168,43.31348,212.68555,88,192,108.68555,147.314,64Z" />
                                    </svg>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    id="w-node-_1b414107-556a-2e31-911b-d880ac5985bf-b74eabf4"
                    className="content"
                  >
                    <div className="text-table red">04</div>
                  </div>
                  <div
                    id="w-node-_1b414107-556a-2e31-911b-d880ac5985c2-b74eabf4"
                    className="content"
                  >
                    <div className="text-table price">$ 30.00</div>
                  </div>
                  <div
                    id="w-node-_1b414107-556a-2e31-911b-d880ac5985c5-b74eabf4"
                    className="content"
                  >
                    <div className="form-block-input w-form">
                      <form
                        id="email-form"
                        name="email-form"
                        data-name="Email Form"
                        method="get"
                        className="form-input select-field"
                      >
                        <div className="select-field-wrapper">
                          <select
                            id="save"
                            name="field-3"
                            data-name="Field 3"
                            className="form-select-field w-select"
                          >
                            <option value="open">Printing</option>
                            <option value="paid">Matting</option>
                            <option value="shipped">Mounting</option>
                            <option value="in production">Framing</option>
                            <option value="Cancelled">Canvas Prod.</option>
                            <option value="on hold">Album Prod.</option>
                            <option value="Another Choice">Ready To Ship</option>
                            <option value="Another Choice">Shipped</option>
                            <option value="Another Choice">Reprint</option>
                            <option value="Another Choice">On Hold</option>
                            <option value="Another Choice">Cancelled</option>
                          </select>
                          <div className="div-block-63">
                            <img
                              src="images/chevron-down-12.svg"
                              loading="lazy"
                              alt=""
                              className="img-icon"
                            />
                          </div>
                        </div>
                      </form>
                      <div className="w-form-done">
                        <div>Thank you! Your submission has been received!</div>
                      </div>
                      <div className="w-form-fail">
                        <div>Oops! Something went wrong while submitting the form.</div>
                      </div>
                    </div>
                  </div>
                  <div
                    id="w-node-_1b414107-556a-2e31-911b-d880ac5985d3-b74eabf4"
                    className="content"
                  >
                    <a
                      href="/lab-orders/unbundled-line-items"
                      aria-label="Unbundled Line Items Link"
                      className="link-block-11 w-inline-block"
                    >
                      <div className="icon w-embed">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="currentcolor"
                          viewBox="0 0 256 256"
                        >
                          <rect width="256" height="256" fill="none" />
                          <path d="M213.58936,82.2749,157.65723,26.34277c-.08008-.08007-.167-.15039-.25-.22656-.10791-.09912-.21289-.20166-.32618-.29492-.07519-.06152-.15576-.11524-.23291-.17432-.13085-.10009-.26025-.20166-.397-.29394-.062-.04151-.12793-.07617-.19043-.11573-.15869-.10009-.31738-.1997-.4834-.28906-.04492-.02392-.09179-.04248-.13672-.06543-.1875-.09668-.377-.18945-.57275-.271-.03027-.0127-.0625-.022-.09326-.03418-.21045-.08448-.42383-.16358-.64258-.23-.03174-.00977-.06445-.01563-.09619-.02491-.2168-.063-.436-.12109-.66064-.166-.07129-.01416-.145-.02051-.2168-.03272-.18555-.03222-.37012-.06494-.55908-.08349A7.91349,7.91349,0,0,0,152,24H55.99219a16.01833,16.01833,0,0,0-16,16V216a16.01833,16.01833,0,0,0,16,16H200a16.01833,16.01833,0,0,0,16-16V88.15479c.001-.05225.00781-.10254.00781-.15479A7.97147,7.97147,0,0,0,213.58936,82.2749Zm-51.93262,79.38233-28,28c-.023.02313-.04883.04223-.07178.06506-.165.16089-.33447.317-.51269.46326-.09766.08032-.20118.15039-.30176.22534-.1084.08111-.21485.1654-.32764.241-.11621.07794-.2373.1455-.35693.21667-.10449.06244-.20655.12817-.31446.18585-.12011.06439-.24414.119-.36669.17676-.11426.05389-.22657.1109-.34327.15942-.11816.049-.23925.08838-.35937.13135-.126.04541-.251.09387-.37988.133-.11963.03613-.24122.06262-.36231.09308-.13184.03338-.26269.07037-.397.097-.13965.02765-.28028.044-.42041.06415-.11817.01691-.23389.03925-.353.051C128.52686,191.986,128.26367,192,128,192s-.52686-.014-.78955-.03986c-.11914-.01171-.23486-.03405-.353-.051-.14013-.02014-.28076-.0365-.42041-.06415-.13428-.02667-.26513-.06366-.397-.097-.12109-.03046-.24268-.057-.36231-.09308-.1289-.03913-.2539-.08759-.37988-.133-.12012-.043-.24121-.0824-.35937-.13135-.1167-.04852-.229-.10553-.34327-.15942-.12255-.0578-.24658-.11237-.36669-.17676-.10791-.05768-.21-.12341-.31446-.18585-.11963-.07117-.24072-.13873-.35693-.21667-.11279-.07557-.21924-.15986-.32764-.241-.10058-.075-.2041-.145-.30176-.22534-.1748-.14374-.3413-.29718-.50341-.455-.02637-.02563-.05518-.04724-.08106-.0733l-28-28a8,8,0,0,1,11.31348-11.314L120,164.68652V120a8,8,0,0,1,16,0v44.68652l14.34326-14.34326a8,8,0,0,1,11.31348,11.314ZM152,88V43.31348L196.68555,88Z" />
                        </svg>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
)

export default UnbundledLineItemsPage
